/* eslint-disable eqeqeq */
/* eslint-disable no-useless-computed-key */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react-hooks/exhaustive-deps */

import { Checkbox, Button, Popover, Tooltip, Image, Input } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import React, { useEffect, useRef, useState } from "react";
import accoArrow from "../../../../assets/acco_arrow-up.svg";
import accoArrowWhite from "../../../../assets/WhiteIcons/acco_arrow-upWhite.svg";
import search_icon from "../../../../assets/search_icon.svg";
import searchWhite_icon from "../../../../assets/WhiteIcons/searchWhite_icon.svg";
import DefaultBrandLogo from "../../../../assets/brandLogos/Default_Brand.svg";
import Blue_check from "../../../../assets/Blue_check.svg";
import Gray_check from "../../../../assets/Gray_check.svg";
import { useDispatch, useSelector } from "react-redux";
import {
  setAddSection,
  setClearProfileFiltersSection,
  setClearProfileFiltersSectionWidgets,
  setFilterObject,
  setTemplateDetails,
  setTemplateSectionBrands,
  setTemplateSectionFilter,
  setTemplateWidgetBrands,
  setTemplateWidgetFilter,
} from "../../../../redux/actions/section/section";
import { setTemplateFilter } from "../../../../redux/actions/section/section";

import {
  setBrandFlag,
  updateDashboardBrands,
  setDashboardBrandObj,
  setClearBrandAndDuration,
  setDashboardProfileFilterObj,
  setSelectProfileId,
  setChannelImage,
  setProfileImage,
} from "../../../../redux/actions/Template";
import {
  getPaneIndex,
  getBrands,
  checkForDuplicateWidgets,
  deepCopy,
  getDuplicateWidgets,
  getFilterDuplicateWidgets,
  getCustomizedDate,
  updateHighchartOptionData,
  callNotification,
  getWidgetMakerFlag,
  getEmptyFieldNotification,
  removePrivateConversationFilters,
  getFormattedBrandsForApi,
  getWidgetMakerBrands,
  splitSectionWidgetsInShare,
} from "../../../../redux/constants";
import { setGraphBrands } from "../../../../redux/actions/dashboard/Welcome";
import {
  setShareSelectedDeepdiveWidget,
  setSharedBrands,
} from "../../../../redux/actions/share/Share";

import {
  setGlobalLogicalBrandValue,
  setGraphPageLogicalBrandValue,
  setSectionLogicalBrandValue,
  setWidgetLogicalBrandValue,
  setLogicalBrandCheckedItems,
  setSelectLogicalBrandValue,
  setPreviewBrands,
} from "../../../../redux/actions/LogicalGroup";
import {
  setWidgetBrands,
  setY_attribute,
} from "../../../../redux/actions/WidgetMaker/GraphConfig";
import {
  setPageChart,
  setProfileList,
  setWidgetMakerGraphData,
} from "../../../../redux/actions/WidgetMaker/WidgetAPI";
import { setGlobalBrands } from "../../../../redux/actions/AuthParams";
import { setIsWidgetEdit } from "../../../../redux/actions/Filter";
import uuid from "react-uuid";
import moment from "moment";
import { setGlobalSelectedWidgetId } from "../../../../redux/actions/dashboard/dashboard";
import isEqual from "react-fast-compare";
import {
  getProfileFilterList,
  resetProfileFilters,
  setConfiguration,
} from "../../../../redux/actions/ApiCall";
import {
  setProfileFilterCheckedItems,
  setSelectProfileFilterValue,
} from "../../../../redux/actions/ProfileFilter";
import {
  setGlobalProfileFilterList,
  setSelectedDeepdiveWidget,
  updateDashboardWidgetProfileFilters,
  setClearGraphDataInShareDashboard,
} from "../../../../redux/actions/dashboard/Tab1";
import {
  setBrandsInScreen,
  setCategoryScreenFilters,
  setCampaignProfileList,
  setCampaignQuickProfile,
  setClearAllScreenWidgetGraphData,
  setOpenCampaignPopup,
  setScreenRefreshEvent,
} from "../../../../redux/actions/commandCenter/screens/screen";
import { setScreenProfileList } from "../../../../redux/actions/commandCenter/commandCenterApi";
import {
  setIsNetworkWidgetSettingEdit,
  setNetworkWidgetSettingObject,
} from "../../../../redux/actions/Network";
import {
  getListOfBrandForThisBrandGroup,
  setBrandsShareBrandsValue,
} from "../../../../redux/actions/ApiCall/apiCall";
import { getDynamicIconColor } from "../../../../redux/constants/DynamicIconColor";
import {
  supportedBenchmarkTraceChartTypes,
  supportedChartTypesForPeakAndValley,
} from "../../../../redux/constants/enums";

const BrandsLogicalGroup = ({ createWorkSpace, type, preview_metadata }) => {
  const [visible, setVisible] = useState(false);
  const graphLoader = useSelector((state) => state.apiCall.loader); //display chart loader
  const aggregateLoader = useSelector((state) => state.apiCall.aggregateLoader);
  const profileLoader = useSelector((state) => state.apiCall.profileLoader);
  const screenCampaignProfileList = useSelector(
    (state) => state?.Screens?.campaign_profile_list
  );
  const screenCampaignQuickProfile = useSelector(
    (state) => state?.Screens?.campaign_quick_profile
  );
  const workspace_privileges = useSelector(
    (state) => state.ApiCall.workspace_privileges
  );
  const brands = useSelector(
    (state) => state?.ApiCall?.brands?.data?.result?.brands
  );
  const loaderForBrandGroupPopover = useSelector(
    (state) => state?.ApiCall?.loaderForBrandGroupPopover
  );
  const [visibleForBrandGroupPopover, setVisibleForBrandGroupPopover] =
    useState({ visible: false, brandGroup: "", index: -1 });
  const [visibleForBrandGroupTooltip, setVisibleForBrandGroupTooltip] =
    useState({ visible: false, brandGroup: "", index: -1 });
  const [brandValue, setBrandValue] = useState(brands);
  const [search, setSearch] = useState("");

  const brandVal = brandValue;

  const selectLogicalBrandValue = useSelector(
    (state) => state?.Logicalgroup.selectLogicalBrandValue
  ); // selected brand values
  const logicalBrandCheckedItems = useSelector(
    (state) => state?.Logicalgroup.logicalBrandCheckedItems
  ); //checked brand values

  const panes = useSelector((state) => state?.Tab1?.panes);
  // store info about command center screen
  const screen = useSelector((state) => state?.Screens?.screen);
  const screenSettings = useSelector(
    (state) => state?.Screens?.screen?.settings
  );
  const activeKey = useSelector((state) => state?.Tab1?.activeKey);
  const editPanelInfo = useSelector((state) => state.dashboard?.editPanelInfo);
  const templateDetails = useSelector((state) => state.Section.templateDetails);
  const Section = useSelector((state) => state.Section.addSection);
  const graphDetail = useSelector((state) => state.Welcome.graphDetail);
  const authParams = useSelector((state) => state.Authentication.authParams);
  const dispatch = useDispatch();
  const ormBrands = useSelector((state) => state.Orm.ormBrands);
  // This is used in case off share-link selection
  const sharedBrands = useSelector((state) => state.Share.sharedBrands);

  // This is used for share dashboard
  const sharedDashboardBrands = useSelector(
    (state) => state?.ApiCall?.shareBrands
  );
  const shareCategory = useSelector((state) => state.ApiCall.shareCategory);
  const shareTemplateData = useSelector(
    (state) => state.ApiCall.shareTemplateData
  );
  const brandlogicalgroup = useSelector(
    (state) => state.ApiCall.brandlogicalgroup?.data?.result
  );
  const selectedSection = useSelector((state) => state.Section.filterObject);

  const competitorBrands = useSelector(
    (state) => state.WidgetAPI.competitorBrands?.data?.result
  );
  const wm_api_flag = useSelector((state) => state.WidgetMaker.wm_api_flag);
  const dashboardBrandObj = useSelector(
    (state) => state?.Template?.dashboardBrandObj
  ); //add in dashboard section and dashboard widget
  const templateDateFilterObj = useSelector(
    (state) => state?.Section?.templateFilterObj
  ); //add in template section and template widget
  const clearBrandAndDuration = useSelector(
    (state) => state?.Template?.clearBrandAndDuration
  ); //contains information about clear filter
  const temporary_words = useSelector(
    (state) => state.attributes.temporary_words
  );
  const personalisationSettingsInPersonalisationState = useSelector(
    (state) => state?.PersonalizationSetting
  );
  // const profileFilterList = useSelector(
  //   (state) => state?.apiCall?.profile_filter_list
  // );
  let index = getPaneIndex(panes, activeKey);
  const profileFilterList =
    window.location.pathname?.split("/")?.[1] === "edit-dashboard" ||
    window.location.pathname?.split("/")?.[1] === "create-dashboard"
      ? templateDetails?.profile_filters_list
      : panes?.[index]?.profile_filters_list;

  const suffix = (
    <img
      src={authParams?.theme_type === "1" ? searchWhite_icon : search_icon}
      alt="search icon"
      style={{ maxWidth: "2.5rem" }}
    />
  );
  const brandTitleContainer = useRef(null);
  const opData = useSelector((state) => state.Highchart.Options);
  const [refreshComponentUI, setRefreshComponentUI] = useState(false);
  const [brandLogicalGroupValue, setBrandLogicalGroupValue] =
    useState(brandlogicalgroup);
  const [competitorBrandsValue, setcompetitorBrandsValue] =
    useState(competitorBrands);
  const [brandLogicalGroupCollapse, setBrandLogicalGroupCollapse] =
    useState(true);
  const [brandListCollapse, setBrandListCollapse] = useState(true);

  const [competitorBrandsCollapse, setCompetitorBrandsCollapse] =
    useState(true);

  const widgetMakerBrands = useSelector(
    (state) => state.GraphConfig.widgetGraphConfig?.brands
  );

  const widgetGraphConfig = useSelector(
    (state) => state?.GraphConfig?.widgetGraphConfig
  );
  const All_WM_attributes = useSelector(
    (state) => state.WidgetMaker.All_WM_attributes
  );
  const previewBrands = useSelector(
    (state) => state?.Logicalgroup.previewBrands
  ); // selected brand values
  const graphConditionConfig = useSelector(
    (state) => state?.apiCall?.graphConditions
  );
  const editWidgetData = useSelector((state) => state.WidgetAPI.widgetPreview);
  const visitedWidgetId = useSelector(
    (state) => state?.dashboard?.visited_widget_id
  );

  const selectProfileFilterValue = useSelector(
    (state) => state?.ProfileFilter?.selectProfileFilterValue
  ); // selected brand values
  const profileFilterCheckedItems = useSelector(
    (state) => state?.ProfileFilter?.profileFilterCheckedItems
  );

  const previewDate = useSelector((state) => state.DateTime.previewDate);
  const widgetPreview = useSelector((state) => state.WidgetAPI.widgetPreview);
  let quick_filters =
    type === "CommandCenter" || type === "CommandCenterCampaign"
      ? graphConditionConfig &&
        graphConditionConfig?.single_brand_select?.includes(screen?.screen_id)
        ? true
        : screen?.quick_filter
        ? true
        : false
      : panes?.[index]?.is_widget_maker_open_obj?.open_flag
      ? false
      : window.location.pathname === "/widgetMaker"
      ? false
      : window.location.pathname === "/edit-widget"
      ? false
      : window.location.pathname === "/dashboard" ||
        window.location.pathname === "/pin-dashboard"
      ? graphConditionConfig &&
        graphConditionConfig?.single_brand_select?.includes(
          panes?.[index]?.template_id
        )
        ? true
        : panes && panes?.[index]?.quick_filter
        ? true
        : false
      : templateDetails?.quick_filter &&
        templateDetails?.quick_filter?.length > 1 &&
        type === "advance_settings"
      ? true
      : false;
  let brandlist_brandgroup_select =
    type === "CommandCenter"
      ? graphConditionConfig &&
        graphConditionConfig?.brandlist_brandgroup_select?.includes(
          screen?.screen_id
        )
        ? true
        : false
      : window.location.pathname === "/widgetMaker"
      ? false
      : window.location.pathname === "/edit-widget"
      ? false
      : window.location.pathname === "/dashboard"
      ? graphConditionConfig &&
        graphConditionConfig?.brandlist_brandgroup_select?.includes(
          panes?.[index]?.template_id
        )
        ? true
        : false
      : false;
  let is_prolific_user =
    (window.location.pathname === "/widgetMaker" || editWidgetData) &&
    widgetGraphConfig?.chart_type === "prolific-user";
  let isOrmUser = workspace_privileges?.login_access_type == 1 ? true : false;
  let widget_metadata =
    type === "preview"
      ? widgetPreview?.metadata
      : editPanelInfo?.type === "dashboard_widget"
      ? panes?.[index]?.sections
        ? panes?.[index]?.sections?.[editPanelInfo?.section_index]?.widgets?.[
            editPanelInfo?.widget_index
          ]
        : panes[index]?.section?.[0].widgets?.[editPanelInfo?.widget_index]
      : editPanelInfo?.type === "template_widget" &&
        Section?.[editPanelInfo?.section_index]?.data?.[
          editPanelInfo?.widget_index
        ];
  const handleOnSelectChange = (e, value, type1, item) => {
    //if we take any action then need to reset clearBrandAndDuration state in case of section/widget level
    if (
      type === "dashboard_section" ||
      type === "dashboard_widget" ||
      type === "template_section" ||
      type === "template_widget"
    ) {
      if (
        !isEqual(
          { ...clearBrandAndDuration },
          {
            sectionLevelBrand: false,
            widgetLevelBrand: false,
            sectionLevelDuration: false,
            widgetLevelDuration: false,
          }
        )
      ) {
        dispatch(
          setClearBrandAndDuration({
            sectionLevelBrand: false,
            widgetLevelBrand: false,
            sectionLevelDuration: false,
            widgetLevelDuration: false,
          })
        );
      }
    }
    //value is key prop for user brands at report creation

    let comp_arr =
      type1 === "competitor" &&
      item?.comp_brand_list?.filter((el, i) => {
        if (i < 5) return el; // here i < 5 is limit to check how many number of selection is allowed to choose from compititor list on initial
      });
    let a = {
      group: type1 === "group" ? true : false,
      name:
        type1 === "group"
          ? e?.target?.value
          : type1 === "competitor"
          ? item?.brand_id
          : value?.brand_id
          ? value?.brand_id
          : "All",
      type: "include",
      brand_name: type1 === "competitor" ? item?.brand_name : value?.brand_name,
      brand_friendly_name:
        type1 === "competitor" ? item?.brand_friendly_name : e?.target?.value,
      brand_color: item?.brand_color,
      brand_group_name: type1 === "group" && e?.target?.value,
      brand_group_list: item?.brand_list ? item?.brand_list : null,
      competitor: type1 === "competitor" ? true : false,
      competitorList:
        type1 === "competitor" &&
        comp_arr?.map((el, i) => {
          return {
            brand_id: el?.comp_brand_id,
            brand_name: el?.comp_brand_name,
            brand_friendly_name: el?.comp_brand_friendly_name,
            comp_brand_color: el?.comp_brand_color,
          };
        }),
      brand_image: item?.brand_logo_image
        ? item?.brand_logo_image
        : value?.brand_logo,
      category_group_id: value?.category_group_id,
    };

    let updatecheckedValue = { ...logicalBrandCheckedItems };
    let updateselectValue = { ...selectLogicalBrandValue };

    let arr =
      type1 === "competitor"
        ? [] //to clear all data
        : selectLogicalBrandValue[type]?.data?.columns
        ? selectLogicalBrandValue[type]?.data?.columns[0]?.competitor
          ? []
          : selectLogicalBrandValue[type]?.data?.columns
        : []; //for template brands
    updatecheckedValue[type].data = //to clear all data when switch from competitor to other brands
      selectLogicalBrandValue[type]?.data?.columns
        ? selectLogicalBrandValue[type]?.data?.columns[0]?.competitor
          ? {}
          : logicalBrandCheckedItems[type]?.data
        : logicalBrandCheckedItems[type]?.data;

    if (arr?.length > 0) {
      if (arr[0].group && type1 !== "group") {
        arr = [];
        updatecheckedValue[type].data = {};
      } else if (!arr[0].group && type1 === "group") {
        arr = [];
        updatecheckedValue[type].data = {};
      } else if (a.name === "All") {
        arr = [];
        updatecheckedValue[type].data = {};
      } else if (
        quick_filters ||
        (templateDetails?.profileInfo && type === "advance_settings") ||
        // is_prolific_user ||
        ((type === "dashboard_widget" ||
          type === "template_widget" ||
          type === "preview") &&
          widget_metadata?.type === "predefined" &&
          !widget_metadata?.multiple_brands)
      ) {
        //for quick filters show only single selection
        arr = [];
        updatecheckedValue[type].data = {};
      }
    }
    let myArr = arr?.filter((item) => {
      return item.name !== a.name && item.name !== "" && item !== null;
    });

    //if check target value is true
    if (e?.target?.checked === true) {
      if (a.name === "All") {
        let check = { ["All"]: true };

        brandVal.map((el, i) => {
          return (check = { ...check, [el?.brand_friendly_name]: true });
        });
        updatecheckedValue[type].data = check;
        dispatch(setLogicalBrandCheckedItems(updatecheckedValue));

        brandVal.map((el, i) => {
          return myArr.push({
            name: el?.brand_id,
            type: "include",
            brand_friendly_name: el?.brand_friendly_name,
            category_group_id: el?.category_group_id,
          });
        });
      } else {
        myArr.push(a);
        let onlyBrands = myArr?.filter((el) => !el?.group);

        if (
          type1 !== "group" &&
          type1 !== "competitor" &&
          brandVal?.length === onlyBrands?.length &&
          !search
        ) {
          updatecheckedValue[type].data["All"] = true;
        }
        updatecheckedValue[type].data[
          type1 === "group" ? e.target.value + "_group" : e.target.value
        ] = e.target.checked;
        dispatch(setLogicalBrandCheckedItems(updatecheckedValue));
      }

      dispatch(setBrandFlag(false));
    } else if (e?.target?.checked === false) {
      if (a.name === "All") {
        let check = { ...updatecheckedValue[type]?.data, ["All"]: false };
        brandVal?.map((el, i) => {
          return (check = { ...check, [el?.brand_friendly_name]: false });
        });
        myArr = selectLogicalBrandValue[type]?.data?.columns
          ? selectLogicalBrandValue[type]?.data?.columns?.filter(
              (el) => el?.group
            )
          : [];
        updatecheckedValue[type].data = check;
        dispatch(setLogicalBrandCheckedItems(updatecheckedValue));
      } else {
        let onlyBrands = myArr?.filter((el) => !el?.group);
        if (brandVal?.length !== onlyBrands?.length) {
          updatecheckedValue[type].data["All"] = false;
        }
        myArr?.filter((item) => {
          return item?.name !== a?.name && item !== "" && item !== null;
        });
        updatecheckedValue[type].data[
          type1 === "group" ? e.target.value + "_group" : e.target.value
        ] = e.target.checked;

        dispatch(setLogicalBrandCheckedItems(updatecheckedValue));
      }
    } else {
      if (
        updateselectValue[type]?.data?.columns[0]?.competitor &&
        item?.brand_friendly_name ===
          updateselectValue[type]?.data?.columns[0]?.brand_friendly_name
      ) {
        updatecheckedValue[type].data = {}; //to clear all data
      } else {
        updatecheckedValue[type].data = {}; //to clear all data
        myArr.push(a);
        updatecheckedValue[type].data[value + "_parent"] =
          !updatecheckedValue[type].data[value + "_parent"];
        a.competitorList?.map(
          (el) =>
            (updatecheckedValue[type].data[
              el?.brand_name + a?.brand_name
            ] = true)
        );
        dispatch(setLogicalBrandCheckedItems(updatecheckedValue));
      }
    }
    updateselectValue[type].data = {
      columns: myArr,
      attribute: "BrandID",
      type: "varchar",
    };
    dispatch(setSelectLogicalBrandValue(updateselectValue));
  };
  const handleOnSelectCompetitor = (e, value, item) => {
    //if we take any action then need to reset clearBrandAndDuration state in case of section/widget level
    if (
      type === "dashboard_section" ||
      type === "dashboard_widget" ||
      type === "template_section" ||
      type === "template_widget"
    ) {
      if (
        !isEqual(
          { ...clearBrandAndDuration },
          {
            sectionLevelBrand: false,
            widgetLevelBrand: false,
            sectionLevelDuration: false,
            widgetLevelDuration: false,
          }
        )
      ) {
        dispatch(
          setClearBrandAndDuration({
            sectionLevelBrand: false,
            widgetLevelBrand: false,
            sectionLevelDuration: false,
            widgetLevelDuration: false,
          })
        );
      }
    }

    //value is key prop for user brands at report creation

    let a = {
      brand_name: value?.comp_brand_name,
      brand_id: value?.comp_brand_id,
      brand_friendly_name: value?.comp_brand_friendly_name,
      comp_brand_color: value?.comp_brand_color,
    };

    let updatecheckedValue = { ...logicalBrandCheckedItems };
    let updateselectValue = { ...selectLogicalBrandValue };
    let arr = selectLogicalBrandValue[type]?.data?.columns[0]?.competitorList
      ? selectLogicalBrandValue[type]?.data?.columns[0]?.competitorList
      : []; //for template brands

    let myArr = arr?.filter((item) => {
      return (
        item.brand_id !== a.brand_id && item.brand_name !== "" && item !== null
      );
    });

    //if check target value is true
    if (e.target.checked === true) {
      if (myArr?.length === 15) {
        // here myArr?.length === 15 is limit to check how many number of selection is allowed to choose from compititor list
        updatecheckedValue[type].data[
          myArr[0]?.brand_name + item?.brand_name
        ] = false;
        myArr.splice(0, 1);
      }
      myArr.push(a);

      updatecheckedValue[type].data[value?.comp_brand_name + item?.brand_name] =
        e.target.checked;
      dispatch(setLogicalBrandCheckedItems(updatecheckedValue));
      dispatch(setBrandFlag(false));
    } else if (e.target.checked === false) {
      updatecheckedValue[type].data[value?.comp_brand_name + item?.brand_name] =
        e.target.checked;

      dispatch(setLogicalBrandCheckedItems(updatecheckedValue));
    }
    updateselectValue[type].data.columns[0].competitorList = myArr;
    dispatch(setSelectLogicalBrandValue(updateselectValue));
  };

  // ========== COMMON UTILITY FUNCTIONS FOR SHARE_DASHBOARD_GLOBAL ==========
  // These functions reduce code duplication and provide consistent filtering logic
  // for brand groups and individual brands across different component methods

  /**
   * Filters available brand groups based on selected brand groups in shared dashboard data
   * @param {Object} sharedData - The shared dashboard brands data
   * @returns {Array} Filtered array of brand groups that match selected criteria
   */
  const getFilteredBrandGroups = (sharedData) => {
    if (!sharedData || !sharedData.selected_brand_groups?.length) return [];

    const availableBrandGroups = sharedData?.brand_groups || [];
    return availableBrandGroups.filter(
      (group) =>
        Array.isArray(sharedData?.selected_brand_groups) &&
        sharedData?.selected_brand_groups?.some(
          (selectedGroup) =>
            (selectedGroup?.brand_group_id &&
              group?.brand_group_id &&
              selectedGroup?.brand_group_id === group?.brand_group_id) ||
            (selectedGroup?.brand_group_name &&
              group?.brand_group_name &&
              selectedGroup?.brand_group_name === group?.brand_group_name)
        )
    );
  };

  /**
   * Filters available individual brands based on selected brand IDs in shared dashboard data
   * @param {Object} sharedData - The shared dashboard brands data
   * @returns {Array} Filtered array of brands that match selected brand IDs
   */
  const getFilteredBrands = (sharedData) => {
    if (!sharedData || !sharedData.selected_brand_ids?.length) return [];

    const availableBrands = sharedData?.brand_list || [];
    return availableBrands?.filter(
      (brand) =>
        Array.isArray(sharedData?.selected_brand_ids) &&
        sharedData?.selected_brand_ids?.some(
          (selectedBrand) =>
            (selectedBrand?.brand_id &&
              brand?.brand_id &&
              selectedBrand?.brand_id === brand?.brand_id) ||
            (selectedBrand?.BrandID &&
              brand?.brand_id &&
              selectedBrand?.BrandID === brand?.brand_id)
        )
    );
  };

  /**
   * Filters competitor brands based on selected competitor brand IDs for share_dashboard_global
   * @param {Object} sharedData - The shared dashboard brands data
   * @returns {Array} Filtered array of competitor brands that match selected competitor brand IDs
   */
  const getFilteredCompetitorBrands = (sharedData) => {
    if (!sharedData || !sharedData.selected_comp_brand_ids?.length) return [];

    const availableCompetitorBrands = sharedData?.comp_brand_list || [];
    return availableCompetitorBrands?.filter(
      (brand) =>
        Array.isArray(sharedData?.selected_brand_ids) && // selected_brand_ids staore parent brand id of competitor
        sharedData?.selected_brand_ids?.some(
          (selectedBrandId) =>
            brand?.brand_id && selectedBrandId?.brand_id === brand?.brand_id
        )
    );
  };

  /**
   * Filters and sets both brand groups and individual brands state for share_dashboard_global
   * @param {Object} sharedData - The shared dashboard brands data
   * @param {boolean} debug - Whether to show debug console logs
   */
  const setFilteredBrandLists = (sharedData, debug = false) => {
    if (!sharedData) return;

    if (debug) {
      console.log("🔧 setFilteredBrandLists called");
      console.log("📊 sharedDashboardBrands:", sharedData);
    }

    const availableBrandGroups = sharedData?.brand_groups || [];
    const availableBrands = sharedData?.brand_list || [];

    if (debug) {
      console.log("🏷️ availableBrandGroups:", availableBrandGroups);
      console.log("📋 availableBrands:", availableBrands);
      console.log(
        "✅ selected_brand_groups:",
        sharedData?.selected_brand_groups
      );
    }

    // Filter and set brand groups
    const filteredBrandGroups = getFilteredBrandGroups(sharedData);

    if (debug) {
      console.log("🔍 Filtering brand groups...");
      console.log(
        "🔢 Available brand groups count:",
        availableBrandGroups?.length
      );
      console.log(
        "🎯 Selected brand groups count:",
        sharedData?.selected_brand_groups?.length || 0
      );
      console.log("✅ filteredBrandGroups count:", filteredBrandGroups?.length);
      console.log("🎯 filteredBrandGroups:", filteredBrandGroups);
    }

    setBrandLogicalGroupValue(filteredBrandGroups);

    if (debug) {
      console.log("✅ setBrandLogicalGroupValue called with filtered groups");
    }

    // Filter and set individual brands
    const filteredBrands = getFilteredBrands(sharedData);

    if (debug) {
      console.log("🎯 filteredBrands:", filteredBrands);
    }

    setBrandValue(filteredBrands);

    // Filter and set competitor brands
    const filteredCompetitorBrands = getFilteredCompetitorBrands(sharedData);

    if (debug) {
      console.log("🏆 filteredCompetitorBrands:", filteredCompetitorBrands);
    }

    setcompetitorBrandsValue(filteredCompetitorBrands);
  };

  // Effect to set filtered brand lists for share_dashboard_global
  useEffect(() => {
    if (type === "share_dashboard_global" && sharedDashboardBrands) {
      // console.log("🔍 share_dashboard_global useEffect triggered");
      setFilteredBrandLists(sharedDashboardBrands, false); // true for debug logs
    }
  }, [type, sharedDashboardBrands]);

  //setting default value to All checked
  useEffect(() => {
    //this is to reset date time values according to types
    if (type !== "share_dashboard_global") {
      !brandLogicalGroupValue && setBrandLogicalGroupValue(brandlogicalgroup);
      !brandVal && setBrandValue(brands);
      !competitorBrandsValue && setcompetitorBrandsValue(competitorBrands);
    } else {
      // For share_dashboard_global, don't override the filtered values set by useEffect
      // console.log(
      //   "⚡ Skipping setBrandLogicalGroupValue override for share_dashboard_global"
      // );
    }
    resetState();
  }, [
    type,
    brandlogicalgroup,
    brands,
    competitorBrands,
    widgetGraphConfig?.widgetResetState,
    templateDetails,
    panes,
    widgetMakerBrands,
    screen?.brand_groups,
    screen?.brand_ids,
    screen?.brands,
    // screen,
  ]);
  const resetState = () => {
    let index = getPaneIndex(panes, activeKey);
    let global_brands = panes[index]?.brands;
    let section_brands =
      editPanelInfo?.type === "dashboard_section" && panes[index]?.sections
        ? panes[index]?.sections[editPanelInfo?.section_index]?.brand_ids
        : null;
    let section_logical_brands =
      editPanelInfo?.type === "dashboard_section" && panes[index]?.sections
        ? panes[index]?.sections[editPanelInfo?.section_index]?.brand_groups
        : null;

    let widget_brands =
      editPanelInfo?.type === "dashboard_widget" && panes[index]?.sections
        ? panes[index]?.sections[editPanelInfo?.section_index]?.widgets &&
          panes[index]?.sections[editPanelInfo?.section_index]?.widgets[
            editPanelInfo?.widget_index
          ]?.brand_ids
        : editPanelInfo?.type === "dashboard_widget" &&
          panes[index]?.section &&
          panes[index]?.section[0]?.widgets
        ? panes[index]?.section[0].widgets[editPanelInfo?.widget_index]
            ?.brand_ids
        : null;
    let widget_logical_brands =
      editPanelInfo?.type === "dashboard_widget" && panes[index]?.sections
        ? panes[index]?.sections[editPanelInfo?.section_index]?.widgets &&
          panes[index]?.sections[editPanelInfo?.section_index]?.widgets[
            editPanelInfo?.widget_index
          ]?.brand_groups
        : editPanelInfo?.type === "dashboard_widget" &&
          panes[index]?.section &&
          panes[index]?.section[0]?.widgets
        ? panes[index]?.section[0].widgets[editPanelInfo?.widget_index]
            ?.brand_groups
        : null;

    let template_brands =
      type === "advance_settings"
        ? templateDetails?.advance_brands
        : templateDetails?.templateBrands;

    let template_section_brands =
      editPanelInfo &&
      Section &&
      editPanelInfo?.type === "template_section" &&
      editPanelInfo?.section_index >= 0 &&
      Section[editPanelInfo?.section_index]?.brands?.length > 0 &&
      Section[editPanelInfo?.section_index]?.brands;
    let template_widget_brands =
      editPanelInfo &&
      editPanelInfo?.type === "template_widget" &&
      editPanelInfo?.section_index >= 0 &&
      editPanelInfo?.widget_index >= 0 &&
      Section &&
      Section[editPanelInfo?.section_index] &&
      Section[editPanelInfo?.section_index]?.data &&
      Section[editPanelInfo?.section_index]?.data[editPanelInfo?.widget_index]
        ?.brands;

    let orm_brands = ormBrands;
    let graph_brands = graphDetail?.brands;

    if (
      brandlogicalgroup ||
      (type === "share_dashboard_global" && sharedDashboardBrands)
    ) {
      if (type === "global_dashboard" && brandlogicalgroup) {
        let brandsObject;
        if (global_brands) {
          brandsObject = {
            type: type,
            value: global_brands?.columns
              ? [global_brands]
              : global_brands[0]?.name
              ? global_brands
              : [
                  {
                    columns: global_brands,
                    attribute: "BrandID",
                    type: "varchar",
                  },
                ],
            brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
            selectLogicalBrandValue: selectLogicalBrandValue,
            logicalBrandCheckedItems: logicalBrandCheckedItems,
            template_type: panes[index]?.template_type
              ? panes[index]?.template_type
              : templateDetails?.template_type,
            competitorBrandsValue: competitorBrandsValue,
            singleBrands: brands,
          };
        } else {
          brandsObject = {
            type: type,
            value: null,
            brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
            selectLogicalBrandValue: selectLogicalBrandValue,
            logicalBrandCheckedItems: logicalBrandCheckedItems,
            template_type: templateDetails?.template_type
              ? templateDetails?.template_type
              : panes[index]?.template_type,
            competitorBrandsValue: competitorBrandsValue,
            singleBrands: brands,
          };
        }
        dispatch(setGlobalLogicalBrandValue(brandsObject));
      }
      if (type === "dashboard_section" && brandlogicalgroup) {
        let brandsObject;
        let brandFilters;
        if (
          dashboardBrandObj?.type === "dashboard_section" &&
          (dashboardBrandObj?.brandFilters?.length ||
            clearBrandAndDuration?.sectionLevelBrand)
        ) {
          brandsObject = {
            type: type,
            value: clearBrandAndDuration?.sectionLevelBrand
              ? null
              : dashboardBrandObj?.brandFilters,
            singleBrands: brands,
            brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
            selectLogicalBrandValue: selectLogicalBrandValue,
            logicalBrandCheckedItems: logicalBrandCheckedItems,
          };
          brandFilters = clearBrandAndDuration?.sectionLevelBrand
            ? null
            : dashboardBrandObj?.brandFilters;
        } else if (section_brands || section_logical_brands) {
          let finalBrand_list =
            section_brands || section_logical_brands
              ? getBrands(
                  brandlogicalgroup,
                  section_brands,
                  brands,
                  section_logical_brands
                )
              : null;
          brandsObject = {
            type: type,
            value: [finalBrand_list],
            singleBrands: brands,
            brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
            selectLogicalBrandValue: selectLogicalBrandValue,
            logicalBrandCheckedItems: logicalBrandCheckedItems,
          };
          brandFilters = [finalBrand_list];
        } else {
          brandsObject = {
            type: type,
            value: null,
            brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
            selectLogicalBrandValue: selectLogicalBrandValue,
            logicalBrandCheckedItems: logicalBrandCheckedItems,
            singleBrands: brands,
          };
          brandFilters = null;
        }

        dispatch(setSectionLogicalBrandValue(brandsObject));
        // to update dashboardBrandObj
        let section_id =
          panes?.[index]?.sections?.[editPanelInfo?.section_index].section_id;
        let paneObject = {
          index: index,
          brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
          panes: panes,
          activeKey: activeKey,
          section_id: section_id,
          brandFilters: brandFilters,
          type: "dashboard_section",
        };
        dispatch(setDashboardBrandObj(paneObject));
      }
      if (type === "dashboard_widget" && brandlogicalgroup) {
        let brandsObject;
        let brandFilters;
        if (
          dashboardBrandObj?.type === "dashboard_widget" &&
          (dashboardBrandObj?.brandFilters?.length ||
            clearBrandAndDuration?.widgetLevelBrand)
        ) {
          brandsObject = {
            type: type,
            value: clearBrandAndDuration?.widgetLevelBrand
              ? null
              : dashboardBrandObj?.brandFilters,
            singleBrands: brands,
            brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
            selectLogicalBrandValue: selectLogicalBrandValue,
            logicalBrandCheckedItems: logicalBrandCheckedItems,
          };
          brandFilters = clearBrandAndDuration?.widgetLevelBrand
            ? null
            : dashboardBrandObj?.brandFilters;
        } else if (widget_brands || widget_logical_brands) {
          let finalBrand_list =
            widget_brands || widget_logical_brands
              ? getBrands(
                  brandlogicalgroup,
                  widget_brands,
                  brands,
                  widget_logical_brands
                )
              : null;
          brandsObject = {
            type: type,
            value: [finalBrand_list],
            singleBrands: brands,
            brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
            selectLogicalBrandValue: selectLogicalBrandValue,
            logicalBrandCheckedItems: logicalBrandCheckedItems,
          };
          brandFilters = [finalBrand_list];
        } else {
          brandsObject = {
            type: type,
            value: null,
            brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
            selectLogicalBrandValue: selectLogicalBrandValue,
            logicalBrandCheckedItems: logicalBrandCheckedItems,
            singleBrands: brands,
          };
          brandFilters = null;
        }

        dispatch(setWidgetLogicalBrandValue(brandsObject));
        // to update dashboardBrandObj
        let section_id = panes[index]?.sections
          ? panes[index]?.sections[editPanelInfo?.section_index].section_id
          : panes[index]?.section && panes[index]?.section[0].section_id;
        let widget_id = panes[index]?.sections
          ? panes[index]?.sections[editPanelInfo?.section_index].widgets[
              editPanelInfo?.widget_index
            ].widget_id
          : panes[index]?.section &&
            panes[index]?.section[0].widgets[editPanelInfo?.widget_index]
              .widget_id;
        let paneObject = {
          index: index,
          brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
          panes: panes,
          activeKey: activeKey,
          section_id: section_id,
          widget_index: editPanelInfo?.widget_index,
          widget_id: widget_id,
          brandFilters: brandFilters,
          type: "dashboard_widget",
        };
        dispatch(setDashboardBrandObj(paneObject));
      }
      if (type === "template_global" && brandlogicalgroup) {
        let brandsObject;

        if (
          template_brands?.length > 0 ||
          template_brands?.columns?.length > 0
        ) {
          brandsObject = {
            type: type,
            value: [
              template_brands?.columns
                ? template_brands
                : {
                    columns: template_brands,
                    attribute: "BrandID",
                    type: "varchar",
                  },
            ],
            brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
            selectLogicalBrandValue: selectLogicalBrandValue,
            logicalBrandCheckedItems: logicalBrandCheckedItems,
            singleBrands: brands,
            template_type: templateDetails?.template_type
              ? templateDetails?.template_type
              : panes[index]?.template_type,
            competitorBrandsValue: competitorBrandsValue,
          };
        } else {
          brandsObject = {
            type: type,
            value: null,
            brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
            selectLogicalBrandValue: selectLogicalBrandValue,
            logicalBrandCheckedItems: logicalBrandCheckedItems,
            singleBrands: brands,
            template_type: templateDetails?.template_type
              ? templateDetails?.template_type
              : panes[index]?.template_type,
            competitorBrandsValue: competitorBrandsValue,
          };
        }

        dispatch(setGlobalLogicalBrandValue(brandsObject));
      }
      if (type === "advance_settings" && brandlogicalgroup) {
        let brandsObject;

        if (
          template_brands?.length > 0 ||
          template_brands?.columns?.length > 0
        ) {
          brandsObject = {
            type: type,
            value: [
              template_brands?.columns
                ? template_brands
                : {
                    columns: template_brands,
                    attribute: "BrandID",
                    type: "varchar",
                  },
            ],
            brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
            selectLogicalBrandValue: selectLogicalBrandValue,
            logicalBrandCheckedItems: logicalBrandCheckedItems,
            singleBrands: brands,
            template_type: templateDetails?.template_type
              ? templateDetails?.template_type
              : panes[index]?.template_type,
            competitorBrandsValue: competitorBrandsValue,
          };
        } else {
          brandsObject = {
            type: type,
            value: brands[0],
            brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
            selectLogicalBrandValue: selectLogicalBrandValue,
            logicalBrandCheckedItems: logicalBrandCheckedItems,
            singleBrands: brands,
            template_type: templateDetails?.template_type
              ? templateDetails?.template_type
              : panes[index]?.template_type,
            competitorBrandsValue: competitorBrandsValue,
          };
        }

        dispatch(setGlobalLogicalBrandValue(brandsObject));
      }
      if (type === "template_section" && brandlogicalgroup) {
        let brandsObject;

        if (template_section_brands) {
          brandsObject = {
            type: type,
            value: template_section_brands,
            global_brands: template_brands,
            brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
            selectLogicalBrandValue: selectLogicalBrandValue,
            logicalBrandCheckedItems: logicalBrandCheckedItems,
            singleBrands: brands,
          };
        } else {
          brandsObject = {
            type: type,

            global_brands: template_brands,
            brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
            selectLogicalBrandValue: selectLogicalBrandValue,
            logicalBrandCheckedItems: logicalBrandCheckedItems,
          };
        }

        dispatch(setSectionLogicalBrandValue(brandsObject));
      }
      if (type === "template_widget" && brandlogicalgroup) {
        let brandsObject;
        if (template_widget_brands) {
          brandsObject = {
            type: type,
            value: template_widget_brands,
            global_brands: template_brands?.length > 0,
            brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
            selectLogicalBrandValue: selectLogicalBrandValue,
            logicalBrandCheckedItems: logicalBrandCheckedItems,
            singleBrands: brands,
          };
        } else {
          brandsObject = {
            type: type,
            global_brands: template_brands,
            brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
            selectLogicalBrandValue: selectLogicalBrandValue,
            logicalBrandCheckedItems: logicalBrandCheckedItems,
          };
        }

        dispatch(setWidgetLogicalBrandValue(brandsObject));
      } else if (type === "graph_page" && brandlogicalgroup) {
        let template_brands = templateDetails?.templateBrands?.columns
          ? templateDetails?.templateBrands?.columns?.length
          : templateDetails?.templateBrands?.length;
        let brandsObject;

        if (graph_brands?.length > 0) {
          brandsObject = {
            type: type,
            brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
            value: graph_brands,
            singleBrands: brands,
            selectLogicalBrandValue: selectLogicalBrandValue,
            logicalBrandCheckedItems: logicalBrandCheckedItems,
          };
        } else if (template_brands > 0) {
          dispatch(
            setGraphBrands(
              templateDetails?.templateBrands?.columns
                ? templateDetails?.templateBrands?.columns
                : templateDetails?.templateBrands,
              graphDetail
            )
          );
          brandsObject = {
            type: type,
            brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
            value: templateDetails?.templateBrands?.columns
              ? templateDetails?.templateBrands?.columns
              : templateDetails?.templateBrands,
            selectLogicalBrandValue: selectLogicalBrandValue,
            logicalBrandCheckedItems: logicalBrandCheckedItems,
            singleBrands: brands,
          };
        } else {
          brandsObject = {
            type: type,
            brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
            selectLogicalBrandValue: selectLogicalBrandValue,
            logicalBrandCheckedItems: logicalBrandCheckedItems,
            singleBrands: brands,
          };
        }

        dispatch(setGraphPageLogicalBrandValue(brandsObject));
      } else if (type === "preview" && brandlogicalgroup) {
        let brandsObject;

        if (previewBrands?.length > 0) {
          brandsObject = {
            type: type,
            brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
            value: previewBrands,
            singleBrands: brands,
            selectLogicalBrandValue: selectLogicalBrandValue,
            logicalBrandCheckedItems: logicalBrandCheckedItems,
          };
        } else {
          brandsObject = {
            type: type,
            brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
            selectLogicalBrandValue: selectLogicalBrandValue,
            logicalBrandCheckedItems: logicalBrandCheckedItems,
            singleBrands: brands,
          };
        }

        dispatch(setGraphPageLogicalBrandValue(brandsObject));
      } else if (type === "orm_dashboard") {
        let brandsObject;
        if (orm_brands) {
          brandsObject = {
            type: type,
            brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
            value: orm_brands,
            selectLogicalBrandValue: selectLogicalBrandValue,
            logicalBrandCheckedItems: logicalBrandCheckedItems,
          };
        } else {
          brandsObject = {
            type: type,
            brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
            selectLogicalBrandValue: selectLogicalBrandValue,
            logicalBrandCheckedItems: logicalBrandCheckedItems,
          };
        }

        dispatch(setGraphPageLogicalBrandValue(brandsObject));
      } else if (type === "share_modal") {
        let brandsObject;
        if (sharedBrands?.columns) {
          brandsObject = {
            type: type,
            brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
            value: sharedBrands?.columns,
            selectLogicalBrandValue: selectLogicalBrandValue,
            logicalBrandCheckedItems: logicalBrandCheckedItems,
            singleBrands: brands,
          };
        } else if (global_brands) {
          brandsObject = {
            type: type,
            value: global_brands?.columns
              ? global_brands?.columns
              : global_brands,
            brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
            selectLogicalBrandValue: selectLogicalBrandValue,
            logicalBrandCheckedItems: logicalBrandCheckedItems,
            singleBrands: brands,
          };
        } else {
          brandsObject = {
            type: type,
            brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
            selectLogicalBrandValue: selectLogicalBrandValue,
            logicalBrandCheckedItems: logicalBrandCheckedItems,
          };
        }

        dispatch(setGraphPageLogicalBrandValue(brandsObject));
      } else if (type === "share_dashboard_global" && sharedDashboardBrands) {
        // console.log("🔧 resetState: share_dashboard_global detected");
        // console.log(
        //   "📊 resetState sharedDashboardBrands:",
        //   sharedDashboardBrands
        // );
        let selectedSharedDashboardBrands = null;
        if (
          sharedDashboardBrands?.brands ||
          sharedDashboardBrands?.selected_brand_ids?.length > 0 ||
          sharedDashboardBrands?.selected_brand_groups?.length > 0
        ) {
          if (sharedDashboardBrands?.brands?.columns) {
            selectedSharedDashboardBrands = sharedDashboardBrands?.brands;
          } else if (
            (sharedDashboardBrands?.selected_brand_ids?.length > 0 ||
              sharedDashboardBrands?.selected_brand_groups?.length > 0) &&
            !(
              sharedDashboardBrands?.selected_comp_brand_ids &&
              sharedDashboardBrands?.selected_comp_brand_ids?.length
            )
          ) {
            // to calculate normal single brand and brand groups
            let selectedBrands = getBrands(
              sharedDashboardBrands?.brand_groups,
              sharedDashboardBrands?.selected_brand_ids,
              sharedDashboardBrands?.brand_list,
              sharedDashboardBrands?.selected_brand_groups
            );
            selectedSharedDashboardBrands = selectedBrands;
          } else if (
            sharedDashboardBrands?.selected_brand_ids?.length > 0 &&
            sharedDashboardBrands?.selected_comp_brand_ids &&
            sharedDashboardBrands?.selected_comp_brand_ids?.length
          ) {
            let parentB = sharedDashboardBrands?.selected_brand_ids?.[0];

            let selectedCompBrand = {
              attribute: "BrandID",
              type: "varchar",
              columns: [
                {
                  group: false,
                  name: parentB?.brand_id,
                  brand_name: parentB?.brand_name,
                  brand_friendly_name: parentB?.brand_friendly_name,
                  type: "include",
                  brand_group_name: false,
                  competitor: true,
                  competitorList:
                    sharedDashboardBrands?.selected_comp_brand_ids,
                },
              ],
            };
            selectedSharedDashboardBrands = selectedCompBrand;
          }
        }

        // console.log(
        //   "✅ selectedSharedDashboardBrands:",
        //   selectedSharedDashboardBrands
        // );
        let value = selectedSharedDashboardBrands
          ? selectedSharedDashboardBrands?.columns?.length > 0
            ? selectedSharedDashboardBrands?.columns
            : selectedSharedDashboardBrands?.length > 0
            ? selectedSharedDashboardBrands
            : null
          : null;

        // Filter to show only selected brand groups and brands
        const selectedBrandGroups =
          sharedDashboardBrands?.brand_groups?.filter(
            (group) =>
              Array.isArray(sharedDashboardBrands?.selected_brand_groups) &&
              sharedDashboardBrands?.selected_brand_groups?.some(
                (selectedGroup) =>
                  selectedGroup?.brand_group_id === group?.brand_group_id ||
                  selectedGroup?.brand_group_name === group?.brand_group_name
              )
          ) || [];

        const selectedBrands =
          (Array.isArray(sharedDashboardBrands?.brand_list) &&
            !(
              Array.isArray(sharedDashboardBrands?.selected_comp_brand_ids) &&
              sharedDashboardBrands?.selected_comp_brand_ids?.length > 0
            ) &&
            sharedDashboardBrands?.brand_list?.filter(
              (brand) =>
                Array.isArray(sharedDashboardBrands?.selected_brand_ids) &&
                sharedDashboardBrands?.selected_brand_ids?.some(
                  (selectedBrand) =>
                    selectedBrand?.brand_id === brand?.brand_id ||
                    selectedBrand?.BrandID === brand?.brand_id
                )
            )) ||
          [];

        const selectedCompetitorBrands =
          (Array.isArray(sharedDashboardBrands?.selected_comp_brand_ids) &&
            sharedDashboardBrands?.selected_comp_brand_ids?.length > 0 &&
            sharedDashboardBrands?.comp_brand_list?.filter(
              (brand) =>
                Array.isArray(sharedDashboardBrands?.selected_brand_ids) &&
                sharedDashboardBrands?.selected_brand_ids?.some(
                  (selectedBrand) =>
                    selectedBrand?.brand_id === brand?.brand_id ||
                    selectedBrand?.BrandID === brand?.brand_id
                )
            )) ||
          [];

        const brandsObject = {
          type: type,
          value: value,
          // Use only filtered selected brands, not all available brands
          brands:
            selectedBrandGroups.length > 0
              ? selectedBrandGroups
              : selectedBrands,
          selectLogicalBrandValue: selectLogicalBrandValue,
          logicalBrandCheckedItems: logicalBrandCheckedItems,
          singleBrands: selectedBrands,
          template_type: shareTemplateData?.template_type
            ? shareTemplateData?.template_type
            : null,
          competitorBrandsValue: selectedCompetitorBrands,
        };

        dispatch(setGraphPageLogicalBrandValue(brandsObject));
      } else if (type === "widgetMaker") {
        // dispatch(
        //   setY_attribute({
        //     ...widgetGraphConfig,
        //     widgetResetState: false,
        //   })
        // );
        let brandsObject;
        if (widgetMakerBrands?.columns || widgetMakerBrands?.length > 0) {
          let defaultBrands =
            widgetMakerBrands?.length > 0 &&
            getBrands(
              brandlogicalgroup,
              widgetMakerBrands,
              brands,
              widgetMakerBrands
            );

          brandsObject = {
            type: type,
            brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,

            value: widgetMakerBrands?.columns
              ? widgetMakerBrands?.columns
              : widgetMakerBrands?.length > 0
              ? widgetMakerBrands[0]?.competitor
                ? widgetMakerBrands
                : widgetMakerBrands
                ? widgetMakerBrands
                : defaultBrands?.columns
              : defaultBrands?.columns,
            selectLogicalBrandValue: selectLogicalBrandValue,
            logicalBrandCheckedItems: logicalBrandCheckedItems,
            singleBrands: brands,
          };
        } else {
          brandsObject = {
            type: type,
            brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
            selectLogicalBrandValue: selectLogicalBrandValue,
            logicalBrandCheckedItems: logicalBrandCheckedItems,
          };
        }

        dispatch(setGraphPageLogicalBrandValue(brandsObject));
      } else if (type === "CommandCenter") {
        // In command center we are currently showing single brand selection
        let brandsObject;
        // if (screen?.brands?.columns || screen?.brands?.length > 0) {
        //   let defaultBrands =
        //     screen?.brands?.length > 0 &&
        //     getBrands(
        //       brandlogicalgroup,
        //       screen?.brands,
        //       brands,
        //       screen?.brands
        //     );
        //   console.log("defaultBrands : ", defaultBrands);
        //   brandsObject = {
        //     type: type,
        //     brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,

        //     value: screen?.brands?.columns
        //       ? screen?.brands?.columns
        //       : screen?.brands?.length > 0
        //       ? screen?.brands[0]?.competitor
        //         ? screen?.brands
        //         : screen?.brands
        //         ? screen?.brands
        //         : defaultBrands?.columns
        //       : defaultBrands?.columns,
        //     selectLogicalBrandValue: selectLogicalBrandValue,
        //     logicalBrandCheckedItems: logicalBrandCheckedItems,
        //     singleBrands: brands,
        //   };
        // } else {
        //   brandsObject = {
        //     type: type,
        //     brands: brands,
        //     selectLogicalBrandValue: selectLogicalBrandValue,
        //     logicalBrandCheckedItems: logicalBrandCheckedItems,
        //   };
        // }
        // dispatch(setGraphPageLogicalBrandValue(brandsObject));

        if (screen?.brands?.columns || screen?.brands?.length > 0) {
          let defaultBrands =
            screen?.brands?.length > 0 &&
            getBrands(
              brandlogicalgroup,
              screen?.brands,
              brands,
              screen?.brands
            );
          brandsObject = {
            type: type,
            brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
            value: screen?.brands?.columns
              ? [screen?.brands]
              : screen?.brands?.length > 0
              ? screen?.brands[0]?.competitor || screen?.brands[0]?.name
                ? screen?.brands
                : screen?.brands && !Array.isArray(screen?.brands)
                ? [screen?.brands]
                : [defaultBrands]
              : [defaultBrands],
            selectLogicalBrandValue: selectLogicalBrandValue,
            logicalBrandCheckedItems: logicalBrandCheckedItems,
            competitorBrandsValue: competitorBrandsValue,
            singleBrands: brands,
            template_type: screen?.screen_type
              ? screen?.screen_type
              : screen?.template_type,
          };
        } else {
          brandsObject = {
            type: type,
            value: null,
            brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
            selectLogicalBrandValue: selectLogicalBrandValue,
            logicalBrandCheckedItems: logicalBrandCheckedItems,
            competitorBrandsValue: competitorBrandsValue,
            singleBrands: brands,
            template_type: screen?.screen_type
              ? screen?.screen_type
              : screen?.template_type,
          };
        }
        dispatch(setGlobalLogicalBrandValue(brandsObject));
      } else if (type === "CommandCenterCampaign") {
        // In command center we are currently showing single brand selection
        let brandsObject;
        let currentScreenBrand =
          selectLogicalBrandValue?.["CommandCenter"]?.data;
        if (currentScreenBrand?.columns || currentScreenBrand?.length > 0) {
          let defaultBrands =
            screen?.brands?.length > 0 &&
            getBrands(
              brandlogicalgroup,
              currentScreenBrand,
              brands,
              currentScreenBrand
            );

          brandsObject = {
            type: type,
            brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,

            value: currentScreenBrand?.columns
              ? currentScreenBrand?.columns
              : currentScreenBrand?.length > 0
              ? currentScreenBrand[0]?.competitor
                ? currentScreenBrand
                : currentScreenBrand
                ? currentScreenBrand
                : defaultBrands?.columns
              : defaultBrands?.columns,
            selectLogicalBrandValue: selectLogicalBrandValue,
            logicalBrandCheckedItems: logicalBrandCheckedItems,
            singleBrands: brands,
          };
        } else {
          brandsObject = {
            type: type,
            brands: brands,
            selectLogicalBrandValue: selectLogicalBrandValue,
            logicalBrandCheckedItems: logicalBrandCheckedItems,
          };
        }
        dispatch(setGraphPageLogicalBrandValue(brandsObject));
      }
    }
  };

  //function to open and close dropdown
  const handleVisibleChange = (newVisible) => {
    if (!newVisible) {
      setVisibleForBrandGroupTooltip({
        visible: false,
        index: -1,
        brandGroup: "",
      });
      setVisibleForBrandGroupPopover({
        visible: false,
        index: -1,
        brandGroup: "",
      });
    }
    setVisible(newVisible);
    setSearch();
    if (type !== "share_dashboard_global") {
      setBrandValue(brands);
      setBrandLogicalGroupValue(brandlogicalgroup);
      setcompetitorBrandsValue(competitorBrands);
    } else {
      // console.log(
      //   "⚡ handleVisibleChange: Skipping override for share_dashboard_global"
      // );
      // For share_dashboard_global, reset to the original filtered values
      setFilteredBrandLists(sharedDashboardBrands, false); // false for no debug logs
    }
  };
  const getBrandListForThisBrandGroup = (
    newVisible,
    brandGroupObject,
    brandGroupIndex
  ) => {
    if (loaderForBrandGroupPopover) return;
    if (newVisible) {
      setVisibleForBrandGroupTooltip({
        visible: false,
        index: brandGroupIndex,
        brandGroup: brandGroupObject?.brand_group_name,
      });
      setVisibleForBrandGroupPopover({
        visible: newVisible,
        index: brandGroupIndex,
        brandGroup: brandGroupObject?.brand_group_name,
      });
      if (
        !(
          Array.isArray(brandGroupObject?.brand_list) &&
          brandGroupObject?.brand_list?.length
        )
      ) {
        let payloadInfo = {
          user_id: authParams?.userid,
          category_name: authParams?.category_name,
          category_id: authParams?.category_id,
          index: brandGroupIndex,
          brand_group_list: [
            {
              brand_group_name: brandGroupObject?.brand_group_name,
            },
          ], // currently supporting single brand group at a time
        };
        dispatch(getListOfBrandForThisBrandGroup(authParams, payloadInfo));
      }
    }
  };
  useEffect(() => {
    if (
      !loaderForBrandGroupPopover &&
      brandLogicalGroupValue &&
      type !== "share_dashboard_global"
    ) {
      setBrandLogicalGroupValue(brandlogicalgroup);
      setRefreshComponentUI(!refreshComponentUI);
    } else if (type === "share_dashboard_global") {
      // console.log("⚡ useEffect: Skipping override for share_dashboard_global");
      // If Required to implement dynamic lazy load brand list then need to here update
    }
  }, [loaderForBrandGroupPopover, brandlogicalgroup]);
  const handleVisibleChangeOfBrandGroupTooltip = (
    newVisible,
    brandGroupObject,
    brandGroupIndex
  ) => {
    if (loaderForBrandGroupPopover) return;
    setVisibleForBrandGroupTooltip({
      visible: newVisible,
      index: brandGroupIndex,
      brandGroup: brandGroupObject?.brand_group_name,
    });
  };
  const controlNavbar = () => {
    if (window.scrollY > 0) {
      handleVisibleChange(false);
    }
  };
  useEffect(() => {
    window.addEventListener("scroll", controlNavbar);
    return () => {
      window.removeEventListener("scroll", controlNavbar);
    };
  }, []);
  const splitSectionWidgets = (updatedSection, type, comBrandList) => {
    let newSection = deepCopy(updatedSection);
    updatedSection?.map((sec, secIndex) => {
      let newDataListForSection = [];
      let secLockedOnBrand =
        type === "template_global" ||
        type === "template_section" ||
        type === "template_widget"
          ? sec?.is_locked &&
            sec?.brands?.length > 0 &&
            (sec?.brands?.[0]?.columns?.length > 0
              ? !sec?.brands?.[0]?.columns?.[0]?.competitor
              : !sec?.brands?.[0]?.competitor)
          : (sec?.is_locked &&
              sec?.brands?.length > 0 &&
              (sec?.brands?.[0]?.columns?.length > 0
                ? !sec?.brands?.[0]?.columns?.[0]?.competitor
                : !sec?.brands?.[0]?.competitor)) ||
            (sec?.is_locked &&
              (sec?.brand_groups?.length > 0 || sec?.brand_ids?.length > 0));
      let comBrandtypeExists =
        sec?.comp_brand_type === false || sec?.comp_brand_type === true
          ? true
          : false;
      if (!secLockedOnBrand && !comBrandtypeExists && sec?.data?.length > 0) {
        sec?.data?.map((el) => {
          let widgetLockedOnBrand =
            type === "template_global" ||
            type === "template_section" ||
            type === "template_widget"
              ? el?.is_locked &&
                el?.brands?.length > 0 &&
                (el?.brands?.[0]?.columns?.length > 0
                  ? !el?.brands?.[0]?.columns?.[0]?.competitor
                  : !el?.brands?.[0]?.competitor)
              : (el?.is_locked &&
                  el?.brands?.length > 0 &&
                  (el?.brands?.[0]?.columns?.length > 0
                    ? !el?.brands?.[0]?.columns?.[0]?.competitor
                    : !el?.brands?.[0]?.competitor)) ||
                (el?.is_locked &&
                  (el?.brand_groups?.length > 0 || el?.brand_ids?.length > 0));
          if (
            !widgetLockedOnBrand &&
            !el?.duplicate_for_brands &&
            el?.chart &&
            (el?.chart?.["chart_type"] === "wordcloud" ||
              el?.chart?.["chart_type"] === "grid" ||
              el?.chart?.["chart_type"] === "post-card" ||
              el?.chart?.["chart_type"] === "author-card") &&
            el?.chart?.["chart_settings"]?.["duplicate_for_brands"]
          ) {
            let newBrandList = [];
            let newl = [];
            if (!comBrandList) {
              if (selectLogicalBrandValue[type]?.data?.columns) {
                newBrandList.push({
                  brand_id:
                    selectLogicalBrandValue[type]?.data?.columns[0]?.name,
                  brand_name:
                    selectLogicalBrandValue[type]?.data?.columns[0]?.brand_name,
                  brand_friendly_name:
                    selectLogicalBrandValue[type]?.data?.columns[0]
                      ?.brand_friendly_name,
                });
                newl =
                  selectLogicalBrandValue[type]?.data?.columns[0]
                    ?.competitorList;
              }
              newBrandList = [...newBrandList, ...newl];
            } else {
              newBrandList = comBrandList;
            }
            let objForTemporyWordFunctionality = null;
            if (el?.chart?.["chart_type"] === "wordcloud") {
              let index = getPaneIndex(panes, activeKey);
              let template_id = panes[index]?.template_id;
              let section_id = sec?.section_id;
              let widget_id = el?.widget_id;
              objForTemporyWordFunctionality = {
                template_id: template_id,
                section_id: section_id,
                widget_id: widget_id,
                temporary_words: temporary_words,
              };
            }

            let duplicateWidgets = getDuplicateWidgets(
              newBrandList,
              el,
              brands,
              objForTemporyWordFunctionality
            );
            if (duplicateWidgets) {
              newDataListForSection = [
                ...newDataListForSection,
                ...duplicateWidgets,
              ];
            } else {
              newDataListForSection.push(el);
            }
          } else {
            newDataListForSection.push(el);
          }
        });
      } else if (
        !secLockedOnBrand &&
        !comBrandtypeExists &&
        sec?.widgets?.length > 0
      ) {
        sec?.widgets?.map((el) => {
          let widgetLockedOnBrand =
            type === "template_global" ||
            type === "template_section" ||
            type === "template_widget"
              ? el?.is_locked &&
                el?.brands?.length > 0 &&
                (el?.brands?.[0]?.columns?.length > 0
                  ? !el?.brands?.[0]?.columns?.[0]?.competitor
                  : !el?.brands?.[0]?.competitor)
              : (el?.is_locked &&
                  el?.brands?.length > 0 &&
                  (el?.brands?.[0]?.columns?.length > 0
                    ? !el?.brands?.[0]?.columns?.[0]?.competitor
                    : !el?.brands?.[0]?.competitor)) ||
                (el?.is_locked &&
                  (el?.brand_groups?.length > 0 || el?.brand_ids?.length > 0));
          if (
            !widgetLockedOnBrand &&
            !el?.duplicate_for_brands &&
            el?.chart &&
            (el?.chart?.["chart_type"] === "wordcloud" ||
              el?.chart?.["chart_type"] === "grid" ||
              el?.chart?.["chart_type"] === "post-card" ||
              el?.chart?.["chart_type"] === "author-card") &&
            el?.chart?.["chart_settings"]?.["duplicate_for_brands"]
          ) {
            let newBrandList = [];
            let newl = [];
            if (type !== "template_widget") {
              if (selectLogicalBrandValue[type]?.data?.columns) {
                newBrandList.push({
                  brand_id:
                    selectLogicalBrandValue[type]?.data?.columns[0]?.name,
                  brand_name:
                    selectLogicalBrandValue[type]?.data?.columns[0]?.brand_name,
                  brand_friendly_name:
                    selectLogicalBrandValue[type]?.data?.columns[0]
                      ?.brand_friendly_name,
                });
                newl =
                  selectLogicalBrandValue[type]?.data?.columns[0]
                    ?.competitorList;
              }
              newBrandList = [...newBrandList, ...newl];
            } else {
              newBrandList = comBrandList;
            }

            let objForTemporyWordFunctionality = null;
            if (el?.chart?.["chart_type"] === "wordcloud") {
              let index = getPaneIndex(panes, activeKey);
              let template_id = panes[index]?.template_id;
              let section_id = sec?.section_id;
              let widget_id = el?.widget_id;
              objForTemporyWordFunctionality = {
                template_id: template_id,
                section_id: section_id,
                widget_id: widget_id,
                temporary_words: temporary_words,
              };
            }
            let duplicateWidgets = getDuplicateWidgets(
              newBrandList,
              el,
              brands,
              objForTemporyWordFunctionality
            );
            if (duplicateWidgets) {
              newDataListForSection = [
                ...newDataListForSection,
                ...duplicateWidgets,
              ];
            } else {
              newDataListForSection.push(el);
            }
          } else {
            newDataListForSection.push(el);
          }
        });
      }
      newSection[secIndex].data =
        secLockedOnBrand || comBrandtypeExists
          ? sec?.data
          : newDataListForSection;
      newSection[secIndex].widgets =
        secLockedOnBrand || comBrandtypeExists
          ? sec?.widgets
          : newDataListForSection;
    });
    return newSection;
  };

  const handleDone = (value) => {
    if (type === "share_modal") {
      dispatch(setSharedBrands(selectLogicalBrandValue[type]?.data));
    }

    if (type === "share_dashboard_global") {
      // Map current logical selection back to ApiCall.shareBrands structure.
      const selCols = selectLogicalBrandValue?.[type]?.data?.columns || [];
      // Handle exploded widgets for share_dashboard_global
      let sections =
        !shareTemplateData?.onlyWidgets && shareTemplateData?.sections
          ? shareTemplateData?.sections
          : Array.isArray(shareTemplateData?.section) && // Only widget case
            shareTemplateData?.section?.length > 0
          ? shareTemplateData?.section
          : null;
      let res = null;
      let newSection = null;

      if (
        sharedDashboardBrands?.selected_brand_ids?.length > 0 &&
        sharedDashboardBrands?.selected_comp_brand_ids?.length > 0 &&
        selCols &&
        selCols[0]?.competitor
      ) {
        res = checkForDuplicateWidgets(sections);
        if (res?.parentExists) {
          let objForTemporyWordFunctionality = {
            template_id: shareTemplateData?.template_id,
            temporary_words: temporary_words,
          };
          let filterSectionData = getFilterDuplicateWidgets(
            sections,
            null,
            objForTemporyWordFunctionality
          );
          if (filterSectionData !== null) {
            // Create brand list for shared dashboard exploded widgets using selectLogicalBrandValue
            let newBrandList = [];
            if (selCols) {
              // Add parent brand (first non-competitor brand)
              const comBrand = selCols[0]; // Always selected brands is competitor so taking first brand as parent
              if (comBrand) {
                newBrandList.push({
                  brand_id: comBrand.name || comBrand.brand_id,
                  brand_name: comBrand.brand_name,
                  brand_friendly_name: comBrand.brand_friendly_name,
                });
              }
              // Add competitor brands
              comBrand?.competitorList?.forEach((competitorBrand) => {
                newBrandList.push(competitorBrand);
              });
            }
            newSection = splitSectionWidgetsInShare(
              filterSectionData,
              newBrandList,
              sharedDashboardBrands?.brand_list
            );
          }
        } else if (res?.duplicateExists) {
          // Create brand list for shared dashboard exploded widgets using selectLogicalBrandValue
          let newBrandList = [];
          if (selCols) {
            // Add parent brand (first non-competitor brand)
            const comBrand = selCols[0]; // Always selected brands is competitor so taking first brand as parent
            if (comBrand) {
              newBrandList.push({
                brand_id: comBrand.name || comBrand.brand_id,
                brand_name: comBrand.brand_name,
                brand_friendly_name: comBrand.brand_friendly_name,
              });
            }
            // Add competitor brands
            comBrand?.competitorList?.forEach((competitorBrand) => {
              newBrandList.push(competitorBrand);
            });
          }
          newSection = splitSectionWidgetsInShare(
            sections,
            newBrandList,
            sharedDashboardBrands?.brand_list
          );
        }
      }

      // Update shared template data with new sections if exploded widgets were processed
      let updatedShareTemplateData = { ...shareTemplateData };
      if (res && (res?.duplicateExists || res?.parentExists) && newSection) {
        if (!shareTemplateData?.onlyWidgets && shareTemplateData?.sections) {
          updatedShareTemplateData.sections = newSection;
        } else {
          updatedShareTemplateData.section = newSection;
        }
      }

      let shareObj = {
        shareBrands: sharedDashboardBrands,
        shareTemplateData: updatedShareTemplateData,
        shareCategory: shareCategory,
        graphConditionConfig: graphConditionConfig,
        change_type: "global_brands",
      };
      dispatch(setClearGraphDataInShareDashboard("share", shareObj));

      // to set global selected widget in redux state to scroll that widget
      dispatch(setGlobalSelectedWidgetId(visitedWidgetId));

      // to clear selected widget deepdive for shared dashboard
      sharedDashboardBrands && dispatch(setShareSelectedDeepdiveWidget(null));

      sharedDashboardBrands &&
        selectLogicalBrandValue[type]?.data?.columns?.length > 0 &&
        dispatch(
          setBrandsShareBrandsValue(selectLogicalBrandValue?.[type]?.data)
        );
    }

    if (type === "global_dashboard") {
      let index = getPaneIndex(panes, activeKey);
      let sections = panes[index]?.sections
        ? panes[index]?.sections
        : panes[index]?.section;
      let res = null;
      let newSection = null;

      if (
        selectLogicalBrandValue[type]?.data?.columns &&
        selectLogicalBrandValue[type]?.data?.columns[0]?.competitor
      ) {
        res = checkForDuplicateWidgets(sections);
        if (res?.parentExists) {
          let template_id = panes[index]?.template_id;
          let objForTemporyWordFunctionality = {
            template_id: template_id,
            temporary_words: temporary_words,
          };
          let filterSectionData = getFilterDuplicateWidgets(
            sections,
            null,
            objForTemporyWordFunctionality
          );
          if (filterSectionData !== null) {
            newSection = splitSectionWidgets(filterSectionData, type);
          }
        } else if (res?.duplicateExists) {
          newSection = splitSectionWidgets(sections, type);
        }
      } else {
        res = checkForDuplicateWidgets(sections);
        if (res?.parentExists) {
          let template_id = panes[index]?.template_id;
          let objForTemporyWordFunctionality = {
            template_id: template_id,
            temporary_words: temporary_words,
          };
          let filterSectionData = getFilterDuplicateWidgets(
            sections,
            null,
            objForTemporyWordFunctionality
          );
          if (filterSectionData !== null) {
            newSection = filterSectionData;
          }
        }
      }

      if (res && (res?.duplicateExists || res?.parentExists) && newSection) {
        if (panes[index]?.sections) {
          panes[index].sections = newSection;
        } else {
          panes[index].section = newSection;
        }
      }

      let paneObject = {
        selectBrands: selectLogicalBrandValue[type]?.data,
        panes: panes,
        activeKey: activeKey,
        brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
        authParams: authParams,
        index: index,
        singleBrands: brands,
        competitorBrands: competitorBrands,
        graphConditionConfig: graphConditionConfig,
        is_modified_date:
          panes?.[index]?.template_id === "000-000-002" ||
          panes?.[index]?.template_id === "000-000-004"
            ? panes?.[index]?.is_modified_date
              ? panes?.[index]?.is_modified_date
              : false
            : null,
        temporary_words: temporary_words,
      };

      let profilePayload = {
        hidden_filter: panes[index]?.hidden_filter,
        quick_filter: panes[index]?.quick_filter,
        saved_filters: panes[index]?.saved_filters,
        isBrandModified: selectLogicalBrandValue[type]?.data
          ? true
          : paneObject?.panes[paneObject?.index]?.brands
          ? true
          : false,
        brands: selectLogicalBrandValue[type]?.data
          ? selectLogicalBrandValue[type]?.data?.columns
          : paneObject?.panes[paneObject?.index]?.brands
          ? paneObject?.panes[paneObject?.index]?.brands?.columns
            ? paneObject?.panes[paneObject?.index]?.brands?.columns
            : paneObject?.panes[paneObject?.index]?.brands
          : paneObject?.brands,
        start_date: paneObject?.panes[paneObject?.index]?.duration
          ? paneObject?.panes[paneObject?.index]?.duration?.from
          : null,
        end_date: paneObject?.panes[paneObject?.index]?.duration
          ? paneObject?.panes[paneObject?.index]?.duration?.to
          : null,
        description: panes[index]?.template_description,
        is_brand_locked: panes[index]?.is_brand_locked,
        is_date_locked: panes[index]?.is_date_locked,
        template_name: panes[index]?.template_name,
        template_id: panes[index]?.template_id,
        predefined: panes[index]?.predefined,
        template_type: panes[index]?.template_type,
        competition_aggregation: panes[index]?.competition_aggregation,
      };
      let section_id = panes[index]?.sections
        ? panes[index]?.sections[0].section_id
        : panes[index]?.section && panes[index]?.section[0].section_id;
      if (panes[index]?.quick_filter) {
        dispatch(
          setProfileList(
            authParams,
            profilePayload,
            paneObject,
            "global_brands",
            section_id
          )
        );
        // clear profile list
        // dispatch({
        //   type: "SET_PROFILE_FILTER_LIST",
        //   payload: null,
        // });

        // Set null profile_filter_list in panes
        dispatch(setGlobalProfileFilterList(null, panes, index));
      } else {
        dispatch(updateDashboardBrands(paneObject));
        let selectedBrands = getFormattedBrandsForApi(
          true,
          selectLogicalBrandValue?.global_dashboard?.data?.columns
        );

        if (panes?.[index]?.template_id === "000-000-002") {
          let paneobject = {
            panes: panes,
            activeKey: activeKey,
            brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
            singleBrands: brands,
            graphConditionConfig: graphConditionConfig,
            selected_brands: selectedBrands,
          };
          dispatch(
            setConfiguration(
              index,
              paneobject,
              authParams,
              null,
              null,
              "tickets/simple-view",
              panes[index].template_id,
              null,
              "brandupdated"
            )
          );
        }

        if (!panes?.[index]?.template_id?.startsWith("000-")) {
          // call Search-Profile API
          dispatch(
            getProfileFilterList(authParams, profilePayload, paneObject)
          );

          let template_id = panes?.[index]?.template_id;
          let widget_id = [];
          let widget_uuid = [];

          panes?.[index]?.sections
            ? panes?.[index]?.sections?.map((sec) => {
                sec?.widgets?.map((widget) => {
                  if (
                    !widget?.is_locked ||
                    (widget?.is_locked &&
                      !widget?.brand_ids &&
                      !widget?.brand_groups)
                  ) {
                    if (widget?.widget_uuid) {
                      widget_uuid = [...widget_uuid, widget?.widget_uuid];
                    } else {
                      widget_id = [...widget_id, widget?.widget_id];
                    }
                  }
                });
              })
            : panes?.[index]?.section?.map((sec) => {
                sec?.widgets?.map((widget) => {
                  if (
                    !widget?.is_locked ||
                    (widget?.is_locked &&
                      !widget?.brand_ids &&
                      !widget?.brand_groups)
                  ) {
                    if (widget?.widget_uuid) {
                      widget_uuid = [...widget_uuid, widget?.widget_uuid];
                    } else {
                      widget_id = [...widget_id, widget?.widget_id];
                    }
                  }
                });
              });

          // Call Reset Filters API
          dispatch(
            resetProfileFilters(authParams, template_id, widget_id, widget_uuid)
          );
        }
      }

      selectLogicalBrandValue[type]?.data?.columns?.length > 0 &&
        dispatch(setGlobalBrands(selectLogicalBrandValue[type]?.data));
      // selectLogicalBrandValue[type]?.data?.columns?.length > 0 &&
      //   dispatch(setSharedBrands(selectLogicalBrandValue[type]?.data));

      // to set global selected widget in redux state to scroll that widget
      dispatch(setGlobalSelectedWidgetId(visitedWidgetId));

      // to clear deep dive selected widget
      dispatch(setSelectedDeepdiveWidget(null, null, panes, index));
    }
    if (
      type === "dashboard_section" &&
      editPanelInfo &&
      selectLogicalBrandValue[type]?.data?.columns?.length
    ) {
      let index = getPaneIndex(panes, activeKey);
      let section_id =
        panes[index]?.sections[editPanelInfo?.section_index].section_id;
      let brandFilters = [selectLogicalBrandValue[type]?.data];

      let paneObject = {
        index: index,
        brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
        panes: panes,
        activeKey: activeKey,
        section_id: section_id,
        brandFilters: brandFilters,
        type: "dashboard_section",
        brand_selected: true,
      };

      dispatch(setDashboardBrandObj(paneObject));
    }

    if (
      type === "dashboard_widget" &&
      editPanelInfo &&
      selectLogicalBrandValue[type]?.data?.columns?.length
    ) {
      let index = getPaneIndex(panes, activeKey);
      let section_id = panes[index]?.sections
        ? panes[index]?.sections[editPanelInfo?.section_index].section_id
        : panes[index]?.section && panes[index]?.section[0].section_id;
      let widget_id = panes[index]?.sections
        ? panes[index]?.sections[editPanelInfo?.section_index].widgets[
            editPanelInfo?.widget_index
          ].widget_id
        : panes[index]?.section &&
          panes[index]?.section[0].widgets[editPanelInfo?.widget_index]
            .widget_id;
      let brandFilters = [selectLogicalBrandValue[type]?.data];

      let paneObject = {
        index: index,
        brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
        panes: panes,
        activeKey: activeKey,
        section_id: section_id,
        widget_index: editPanelInfo?.widget_index,
        widget_id: widget_id,
        brandFilters: brandFilters,
        type: "dashboard_widget",
      };

      dispatch(setDashboardBrandObj(paneObject));

      // call Search-Profile API start
      let widget_metadata = panes[index]?.sections
        ? panes[index]?.sections[editPanelInfo?.section_index].widgets[
            editPanelInfo?.widget_index
          ]
        : panes[index]?.section &&
          panes[index]?.section[0].widgets[editPanelInfo?.widget_index];

      if (widget_metadata?.profile_filters_flag) {
        dispatch(setFilterObject(selectedSection, true));
        if (!selectedSection?.is_locked) {
          callNotification("Selected widget is locked", "success");
        }

        let profilePayload = {
          hidden_filter: panes[index]?.hidden_filter,
          quick_filter: panes[index]?.quick_filter,
          isBrandModified: selectLogicalBrandValue[type]?.data
            ? true
            : paneObject?.panes[paneObject?.index]?.brands
            ? true
            : false,
          brands: selectLogicalBrandValue[type]?.data
            ? selectLogicalBrandValue[type]?.data?.columns
            : paneObject?.panes[paneObject?.index]?.brands
            ? paneObject?.panes[paneObject?.index]?.brands?.columns
              ? paneObject?.panes[paneObject?.index]?.brands?.columns
              : paneObject?.panes[paneObject?.index]?.brands
            : paneObject?.brands,
          start_date: paneObject?.panes[paneObject?.index]?.duration
            ? paneObject?.panes[paneObject?.index]?.duration?.from
            : null,
          end_date: paneObject?.panes[paneObject?.index]?.duration
            ? paneObject?.panes[paneObject?.index]?.duration?.to
            : null,
          description: panes[index]?.template_description,
          is_brand_locked: panes[index]?.is_brand_locked,
          is_date_locked: panes[index]?.is_date_locked,
          template_name: panes[index]?.template_name,
          template_id: panes[index]?.template_id,
          predefined: panes[index]?.predefined,
          template_type: panes[index]?.template_type,
          competition_aggregation: panes[index]?.competition_aggregation,
        };

        let sectionObj = {
          panes: panes,
          index: index,
          section_index: editPanelInfo?.section_index,
          widget_index: editPanelInfo?.widget_index,
          singleBrands: brands,
        };

        paneObject.metadata = widget_metadata;
        paneObject.metadata.profile_filters = null;
        paneObject.widget_brand_change = true;
        paneObject.sectionIndex = editPanelInfo?.section_index;
        paneObject.sectionObj = sectionObj;

        dispatch(getProfileFilterList(authParams, profilePayload, paneObject));

        // to reset dashboard Profile Filter Object
        dispatch(setDashboardProfileFilterObj(null));
      }
    }
    if (type === "template_global") {
      let res = null;
      let newSection = null;
      let final_filters;
      if (
        templateDetails?.comp_hidden_filter?.length &&
        !selectLogicalBrandValue[type]?.data?.columns[0]?.competitor
      ) {
        final_filters = removePrivateConversationFilters(
          templateDetails?.comp_hidden_filter,
          templateDetails?.templateFilters
        );
        callNotification(
          "Filters updated by including Private conversations",
          "info"
        );
      }
      if (
        selectLogicalBrandValue[type]?.data?.columns &&
        selectLogicalBrandValue[type]?.data?.columns[0]?.competitor
      ) {
        res = checkForDuplicateWidgets(Section);
        if (res?.parentExists) {
          let filterSectionData = getFilterDuplicateWidgets(Section);
          if (filterSectionData !== null) {
            newSection = splitSectionWidgets(filterSectionData, type);
          }
        } else if (res?.duplicateExists) {
          newSection = splitSectionWidgets(Section, type);
        }
      } else {
        res = checkForDuplicateWidgets(Section);
        if (res?.parentExists) {
          let filterSectionData = getFilterDuplicateWidgets(Section);
          if (filterSectionData !== null) {
            newSection = filterSectionData;
          }
        }
      }

      let templateObject = {
        selectBrands: selectLogicalBrandValue[type]?.data,
        duration: templateDetails?.templateDuration,
        brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
        singleBrands: brands,
        authParams: authParams,
        templateDetails: templateDetails,
        section:
          res && (res?.duplicateExists || res?.parentExists) && newSection
            ? newSection
            : Section,
        filters: templateDetails?.templateFilters
          ? templateDetails?.templateFilters
          : [],
        type: type,
        change_type: "global_brands",
        graphConditionConfig: graphConditionConfig,
      };
      if (res && (res?.duplicateExists || res?.parentExists) && newSection) {
        let update = {
          templateDetails: templateDetails,
          newTemplateDetails: {
            brands: selectLogicalBrandValue[type]?.data,
            template_type: selectLogicalBrandValue[type]?.data?.columns[0]
              ?.competitor
              ? "competition"
              : "custom",
            filters: final_filters
              ? final_filters
              : templateDetails?.templateFilters,
            comp_hidden_filter: !selectLogicalBrandValue[type]?.data?.columns[0]
              ?.competitor
              ? []
              : templateDetails?.comp_hidden_filter,
          },
          template: templateObject,
          sectionUpdate: true,
          graphDetail: graphDetail,
          graphBrand: selectLogicalBrandValue[type]?.data?.columns,
        };
        dispatch(setAddSection(Section, newSection, update));
      } else {
        dispatch(
          setTemplateDetails(templateDetails, {
            brands: selectLogicalBrandValue[type]?.data,
            template_type: selectLogicalBrandValue[type]?.data?.columns[0]
              ?.competitor
              ? "competition"
              : "custom",
            dashboard_called_api_list: [],
            filters: final_filters
              ? final_filters
              : templateDetails?.templateFilters,
            comp_hidden_filter: !selectLogicalBrandValue[type]?.data?.columns[0]
              ?.competitor
              ? []
              : templateDetails?.comp_hidden_filter,
          })
        );

        dispatch(
          setGraphBrands(
            selectLogicalBrandValue[type]?.data?.columns,
            graphDetail
          )
        );
        // we are call api through getTemplateFilter, so here we stop previous api calls because here we perform global level changes
        window?.stop();

        // clear profile list
        // dispatch({
        //   type: "SET_PROFILE_FILTER_LIST",
        //   payload: null,
        // });

        // Set null profile_filter_list in panes
        // dispatch(setGlobalProfileFilterList(null, panes, index));

        // call Search-Profile API start
        let paneObject = {
          selectBrands: selectLogicalBrandValue[type]?.data,
          panes: panes,
          activeKey: activeKey,
          brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
          authParams: authParams,
          index: index,
          singleBrands: brands,
          competitorBrands: competitorBrands,
          graphConditionConfig: graphConditionConfig,
          temporary_words: temporary_words,
          templateObject: templateObject,
        };

        // Update payload here
        let profilePayload = {
          isBrandModified: true,
          brands: selectLogicalBrandValue[type]?.data
            ? selectLogicalBrandValue[type]?.data?.columns
            : paneObject?.brands,
        };
        paneObject.setTemplateGlobalFilter = true;
        dispatch(getProfileFilterList(authParams, profilePayload, paneObject));
        // call Search-Profile API end

        // Commented, it will call inside getProfileFilterList
        // dispatch(setTemplateFilter(templateObject));

        // clear States
        let dashboard_type = "template_widget";
        let updatecheckedValue = { ...profileFilterCheckedItems };
        let updateselectValue = { ...selectProfileFilterValue };
        updatecheckedValue[dashboard_type].data = {};
        dispatch(setProfileFilterCheckedItems(updatecheckedValue));
        updateselectValue[dashboard_type].data = {
          columns: [],
          attribute: "SocialMediaProfiles",
          type: "varchar",
        };
        dispatch(setSelectProfileFilterValue(updateselectValue));
      }

      // Clear profile_filters of all widgets on change of global brands
      dispatch(setClearProfileFiltersSection(Section));

      // to update brands
      selectLogicalBrandValue[type]?.data?.columns?.length > 0 &&
        dispatch(setGlobalBrands(selectLogicalBrandValue[type]?.data));
    }
    if (type === "advance_settings") {
      dispatch(
        setTemplateDetails(templateDetails, {
          advance_brands: selectLogicalBrandValue[type]?.data,
        })
      );
      let index = getPaneIndex(panes, activeKey);
      let paneObject = {
        selectBrands: selectLogicalBrandValue[type]?.data,
        panes: panes,
        activeKey: activeKey,
        brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
        authParams: authParams,
        index: index,
        singleBrands: brands,
      };
    }
    if (
      type === "template_section" &&
      selectLogicalBrandValue[type]?.data?.columns?.length
    ) {
      if (selectedSection?.is_locked) {
        let res = null;
        let newSection = null;
        let currectSection = Section?.[editPanelInfo?.section_index];
        if (
          selectLogicalBrandValue[type]?.data?.columns &&
          selectLogicalBrandValue?.[type]?.data?.columns?.[0]?.competitor
        ) {
          res = checkForDuplicateWidgets([currectSection]);
          if (res?.parentExists) {
            let filterSectionData = getFilterDuplicateWidgets([currectSection]);
            if (filterSectionData !== null) {
              newSection = splitSectionWidgets(filterSectionData, type);
            }
          } else if (res?.duplicateExists) {
            newSection = splitSectionWidgets([currectSection], type);
          }
        } else {
          res = checkForDuplicateWidgets([currectSection]);
          if (res?.parentExists) {
            let filterSectionData = getFilterDuplicateWidgets([currectSection]);
            if (filterSectionData !== null) {
              newSection = filterSectionData;
            }
          }
        }
        if (res && (res?.duplicateExists || res?.parentExists) && newSection) {
          Section[editPanelInfo?.section_index] = newSection?.[0];
        }
      }

      let templateObj1 = {
        section: Section,
        templateDetails: templateDetails,
        section_index: editPanelInfo?.section_index,
        authParams: authParams,
        brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,

        selectBrands: selectLogicalBrandValue[type]?.data,
      };
      dispatch(setTemplateSectionBrands(templateObj1));
      let global = templateDetails?.templateFilters
        ? templateDetails?.templateFilters
        : [];

      let global_brands = templateDetails?.templateBrands
        ? templateDetails?.templateBrands
        : null;
      let global_duration = templateDetails?.templateDuration
        ? templateDetails?.templateDuration
        : null;

      let templateObj = {
        section: Section,
        templateDetails: templateDetails,
        section_index: selectedSection?.section_index,
        authParams: authParams,
        brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
        global_brands: selectedSection?.is_locked
          ? templateObj1?.selectBrands
            ? templateObj1?.selectBrands
            : Section[selectedSection?.section_index]?.brandFilters
          : global_brands,
        filters: value
          ? value
          : Section[selectedSection?.section_index]?.onlyFilters,
        duration: selectedSection?.is_locked
          ? templateDateFilterObj?.templateObj?.durationObj
            ? templateDateFilterObj?.templateObj?.durationObj
            : Section[selectedSection?.section_index]?.dateFilters
            ? Section[selectedSection?.section_index]?.dateFilters
            : global_duration
          : global_duration,
        is_locked: selectedSection?.is_locked,
        brandFilters: templateObj1?.selectBrands
          ? templateObj1?.selectBrands
          : Section[selectedSection?.section_index]?.brandFilters,
        dateFilters:
          // templateDateFilterObj?.templateObj?.durationObj
          // ? templateDateFilterObj?.templateObj?.durationObj
          // :
          Section[selectedSection?.section_index]?.dateFilters,
        clear: false,
        profile_filters: null,
        profile_filters_list: [],
        profile_filters_flag: widget_metadata?.profile_filters_flag,
      };

      dispatch(setTemplateSectionFilter(templateObj, false));

      let obj = {
        type: "template_section",
        filters: global,
        section: Section,
        brands: templateDetails?.brands
          ? templateDetails?.brands
          : brandlogicalgroup?.length > 0
          ? brandlogicalgroup
          : brands,
        authParams: authParams,
        duration: templateDetails?.templateDuration
          ? templateDetails?.templateDuration
          : null,
        currentFilter: value ? value : [],
        graphConditionConfig: graphConditionConfig,
      };
      dispatch(setIsWidgetEdit(false));
      dispatch(setIsNetworkWidgetSettingEdit(false));
      dispatch(setNetworkWidgetSettingObject(null));

      let section_metadata = Section?.[editPanelInfo?.section_index];
      let profile_filter_widget;
      section_metadata?.data?.map((d) => {
        if (d?.profile_filters_flag) {
          profile_filter_widget = true;
        }
      });

      if (profile_filter_widget) {
        // profile filters widget present in section / Call search-profile api
        let paneObject = {
          selectBrands: selectLogicalBrandValue[type]?.data,
          panes: panes,
          activeKey: activeKey,
          brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
          authParams: authParams,
          index: index,
          singleBrands: brands,
          competitorBrands: competitorBrands,
          graphConditionConfig: graphConditionConfig,
          temporary_words: temporary_words,
        };
        // Update payload here
        let profilePayload = {
          isBrandModified: true,
          brands: selectLogicalBrandValue[type]?.data
            ? selectLogicalBrandValue[type]?.data?.columns
            : paneObject?.brands,
        };
        paneObject.metadata = widget_metadata;
        paneObject.setTemplateSectionFilter = true;
        paneObject.templateFilter_obj = obj;
        paneObject.templateFilter_templateObj = templateObj;

        paneObject.section_index = editPanelInfo?.section_index;
        paneObject.widget_index = editPanelInfo?.widget_index;
        paneObject.widget_id = widget_metadata?.widget_id;

        dispatch(getProfileFilterList(authParams, profilePayload, paneObject));
      } else {
        dispatch(setTemplateFilter(obj, templateObj));
      }

      // clear profile filters of section widgets only in section
      dispatch(
        setClearProfileFiltersSectionWidgets(
          Section,
          editPanelInfo?.section_index
        )
      );
    }
    if (
      type === "template_widget" &&
      selectLogicalBrandValue[type]?.data?.columns?.length
    ) {
      let widget_metadata =
        editPanelInfo?.section_index >= 0
          ? Section?.[editPanelInfo?.section_index]?.data?.[
              editPanelInfo?.widget_index
            ]
          : Section?.[0]?.data?.[editPanelInfo?.widget_index];

      let templateObj1 = {
        section: Section,
        templateDetails: templateDetails,
        section_index: editPanelInfo?.section_index,
        authParams: authParams,
        widget_index: editPanelInfo?.widget_index,
        brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
        selectBrands: selectLogicalBrandValue[type]?.data,
      };
      dispatch(setTemplateWidgetBrands(templateObj1));

      let global = templateDetails?.templateFilters
        ? templateDetails?.templateFilters
        : [];

      let global_brands = templateDetails?.templateBrands
        ? templateDetails?.templateBrands
        : null;

      let global_duration = templateDetails?.templateDuration
        ? templateDetails?.templateDuration
        : null;

      let section_profile_filters_list =
        editPanelInfo?.section_index >= 0
          ? Section?.[editPanelInfo?.section_index]?.profile_filters_list
          : Section?.[0]?.profile_filters_list;

      let widget_profile_filters_list =
        editPanelInfo?.section_index >= 0
          ? Section?.[editPanelInfo?.section_index]?.data?.[
              editPanelInfo?.widget_index
            ]?.profile_filters_list
          : Section?.[0]?.data?.[editPanelInfo?.widget_index]
              ?.profile_filters_list;

      let profile_filters = selectProfileFilterValue[type]?.data;
      let res = null;
      let newSection = deepCopy(Section);
      let updatedSection = null;
      let currectSection = deepCopy(Section?.[editPanelInfo?.section_index]);
      let forParticularSection = {
        section_index: selectedSection?.section_index
          ? selectedSection?.section_index
          : 0,
        section_id: currectSection?.id,
        widget_id: selectedSection?.id,
        widget_index: selectedSection?.widget_index,
      };
      // if dupliates widget exists and global brand is competitor then need split again
      let secLockedOnBrand =
        currectSection?.is_locked &&
        currectSection?.brands &&
        currectSection?.brands?.length > 0 &&
        (currectSection?.brands?.[0]?.columns?.length > 0
          ? !currectSection?.brands?.[0]?.columns?.[0]?.competitor
          : !currectSection?.brands?.[0]?.competitor);
      let comBrandtypeExists =
        currectSection?.comp_brand_type === false ||
        currectSection?.comp_brand_type === true
          ? true
          : false;
      let currectWidget =
        currectSection?.data && currectSection?.data?.length > 0
          ? currectSection?.data?.[selectedSection?.widget_index]
          : currectSection?.widgets?.[selectedSection?.widget_index];
      let widgetLockedOnBrand =
        selectedSection?.is_locked &&
        currectWidget?.brands?.length > 0 &&
        (currectWidget?.brands?.[0]?.columns?.length > 0
          ? !currectWidget?.brands?.[0]?.columns?.[0]?.competitor
          : !currectWidget?.brands?.[0]?.competitor);
      let comBrand = global_brands?.columns?.[0]?.competitor
        ? global_brands?.columns?.[0]
        : global_brands?.[0]?.competitor
        ? global_brands?.[0]
        : global_brands?.competitor
        ? global_brands
        : null;
      if (
        comBrand &&
        !secLockedOnBrand &&
        !comBrandtypeExists &&
        !widgetLockedOnBrand &&
        currectWidget?.chart &&
        currectWidget?.chart?.["chart_settings"]["duplicate_for_brands"]
      ) {
        res = checkForDuplicateWidgets(newSection, forParticularSection);
        if (res?.parentExists) {
          let filterSectionData = getFilterDuplicateWidgets(
            newSection,
            forParticularSection
          );
          if (filterSectionData !== null) {
            let iOfW = filterSectionData?.[forParticularSection?.section_index]
              ?.data?.length
              ? filterSectionData?.[
                  forParticularSection?.section_index
                ]?.data?.findIndex(
                  (el) => el?.widget_id === forParticularSection?.widget_id
                )
              : filterSectionData?.[
                  forParticularSection?.section_index
                ]?.widgets?.findIndex(
                  (el) => el?.widget_id === forParticularSection?.widget_id
                );
            if (iOfW !== -1) {
              // if (
              //   filterSectionData?.[forParticularSection?.section_index]?.data
              //     ?.length
              // ) {
              //   filterSectionData[forParticularSection?.section_index].data[
              //     iOfW
              //   ] = currectWidget; // need to assign updated widget metadata
              // } else {
              //   filterSectionData[forParticularSection?.section_index].widgets[
              //     iOfW
              //   ] = currectWidget; // need to assign updated widget metadata
              // }
            }
            let newBrandList = [];
            newBrandList.push({
              brand_id: comBrand?.name,
              brand_name: comBrand?.brand_name,
              brand_friendly_name: comBrand?.brand_friendly_name,
            });
            comBrand?.competitorList?.forEach((competitorBrand) => {
              newBrandList.push(competitorBrand);
            });
            updatedSection = splitSectionWidgets(
              filterSectionData,
              type,
              newBrandList
            );
          }
        } else if (res?.duplicateExists) {
          let newBrandList = [];
          newBrandList.push({
            brand_id: comBrand?.name,
            brand_name: comBrand?.brand_name,
            brand_friendly_name: comBrand?.brand_friendly_name,
          });
          comBrand?.competitorList?.forEach((competitorBrand) => {
            newBrandList.push(competitorBrand);
          });
          updatedSection = splitSectionWidgets(newSection, type, newBrandList);
        }
      } else if (
        currectWidget?.chart &&
        currectWidget?.chart?.["chart_settings"]["duplicate_for_brands"]
      ) {
        res = checkForDuplicateWidgets(newSection, forParticularSection);
        if (res?.parentExists) {
          let filterSectionData = getFilterDuplicateWidgets(
            newSection,
            forParticularSection
          );
          if (filterSectionData !== null) {
            let iOfW = filterSectionData?.[forParticularSection?.section_index]
              ?.data?.length
              ? filterSectionData?.[
                  forParticularSection?.section_index
                ]?.data?.findIndex(
                  (el) => el?.widget_id === forParticularSection?.widget_id
                )
              : filterSectionData?.[
                  forParticularSection?.section_index
                ]?.widgets?.findIndex(
                  (el) => el?.widget_id === forParticularSection?.widget_id
                );
            if (iOfW !== -1) {
              // if (
              //   filterSectionData?.[forParticularSection?.section_index]?.data
              //     ?.length
              // ) {
              //   filterSectionData[forParticularSection?.section_index].data[
              //     iOfW
              //   ] = currectWidget; // need to assign updated widget metadata
              // } else {
              //   filterSectionData[forParticularSection?.section_index].widgets[
              //     iOfW
              //   ] = currectWidget; // need to assign updated widget metadata
              // }
            }
            updatedSection = filterSectionData;
          }
        }
      }
      let needToBeUpdateSectionAllWidgetsWithId = null;
      if (
        res &&
        (res?.duplicateExists || res?.parentExists) &&
        updatedSection
      ) {
        Section[editPanelInfo?.section_index] =
          updatedSection?.[editPanelInfo?.section_index];
        needToBeUpdateSectionAllWidgetsWithId = {
          ...forParticularSection,
        };
      }

      let templateObj = {
        section: Section,
        templateDetails: templateDetails,
        section_index: selectedSection?.section_index,
        widget_index: selectedSection?.widget_index,
        authParams: authParams,
        global_brands: selectedSection?.is_locked
          ? templateObj1?.selectBrands
            ? templateObj1?.selectBrands
            : selectedSection?.section_index
            ? Section[selectedSection?.section_index]?.data[
                selectedSection?.widget_index
              ]?.brandFilters
            : Section[0]?.data[selectedSection?.widget_index]?.brandFilters
          : global_brands,
        brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
        filters: value
          ? value
          : selectedSection?.section_index
          ? Section[selectedSection?.section_index]?.data[
              selectedSection?.widget_index
            ]?.onlyFilters
          : Section[0]?.data[selectedSection?.widget_index]?.onlyFilters,
        duration: selectedSection?.is_locked
          ? templateDateFilterObj?.templateObj?.durationObj
            ? templateDateFilterObj?.templateObj?.durationObj
            : Section[selectedSection?.section_index]?.dateFilters
            ? Section[selectedSection?.section_index]?.dateFilters
            : global_duration
          : global_duration,
        is_locked: widget_metadata?.profile_filters_flag
          ? true
          : selectedSection?.is_locked,
        brandFilters: templateObj1?.selectBrands
          ? templateObj1?.selectBrands
          : selectedSection?.section_index
          ? Section[selectedSection?.section_index]?.data[
              selectedSection?.widget_index
            ]?.brandFilters
          : Section[0]?.data[selectedSection?.widget_index]?.brandFilters,
        dateFilters:
          // templateDateFilterObj?.templateObj?.durationObj
          //   ? templateDateFilterObj?.templateObj?.durationObj
          //   :
          selectedSection?.section_index
            ? Section[selectedSection?.section_index]?.data[
                selectedSection?.widget_index
              ]?.dateFilters
            : Section[0]?.data[selectedSection?.widget_index]?.dateFilters,
        clear: false,
        span_check:
          templateDateFilterObj?.templateObj?.durationObj ||
          templateObj1?.selectBrands ||
          value?.length > 0
            ? true
            : false,
        brand_ids: selectLogicalBrandValue[type]?.data?.columns?.[0]?.name && {
          brand_id: selectLogicalBrandValue?.[type]?.data?.columns?.[0]?.name,
          brand_name:
            selectLogicalBrandValue?.[type]?.data?.columns?.[0]?.brand_name,
        },
        brand_groups: selectLogicalBrandValue[type]?.data,
        profile_filters: null,
        profile_filters_list:
          section_profile_filters_list?.length > 0
            ? section_profile_filters_list
            : widget_profile_filters_list?.length > 0
            ? widget_profile_filters_list
            : profileFilterList,
        profile_filters_flag: widget_metadata?.profile_filters_flag,
      };

      dispatch(
        setTemplateWidgetFilter(
          templateObj,
          false,
          null,
          needToBeUpdateSectionAllWidgetsWithId
        )
      );

      let obj = {
        type: "template_widget",
        filters: global,
        section: templateObj1?.section ? templateObj1?.section : Section,
        brands: templateDetails?.brands
          ? templateDetails?.brands
          : brandlogicalgroup?.length > 0
          ? brandlogicalgroup
          : brands,
        authParams: authParams,
        duration: templateDetails?.templateDuration
          ? templateDetails?.templateDuration
          : null,
        currentFilter: value ? value : [],
        graphConditionConfig: graphConditionConfig,
      };
      dispatch(setIsWidgetEdit(false));
      dispatch(setIsNetworkWidgetSettingEdit(false));
      dispatch(setNetworkWidgetSettingObject(null));
      if (widget_metadata?.profile_filters_flag) {
        dispatch(setFilterObject(selectedSection, true));
        if (!selectedSection?.is_locked) {
          callNotification("Selected widget is locked", "success");
        }

        let paneObject = {
          selectBrands: selectLogicalBrandValue[type]?.data,
          panes: panes,
          activeKey: activeKey,
          brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
          authParams: authParams,
          index: index,
          singleBrands: brands,
          competitorBrands: competitorBrands,
          graphConditionConfig: graphConditionConfig,
          temporary_words: temporary_words,
        };
        // Update payload here
        let profilePayload = {
          isBrandModified: true,
          brands: selectLogicalBrandValue[type]?.data
            ? selectLogicalBrandValue[type]?.data?.columns
            : paneObject?.brands,
        };
        paneObject.metadata = widget_metadata;
        paneObject.setTemplateFilter = true;
        paneObject.templateFilter_obj = obj;
        paneObject.templateFilter_templateObj = templateObj;

        paneObject.section_index = editPanelInfo?.section_index;
        paneObject.widget_index = editPanelInfo?.widget_index;
        paneObject.widget_id = widget_metadata?.widget_id;

        dispatch(getProfileFilterList(authParams, profilePayload, paneObject));
      } else {
        dispatch(setTemplateFilter(obj, templateObj));
      }
    }

    if (type === "graph_page") {
      dispatch(
        setGraphBrands(
          selectLogicalBrandValue[type]?.data?.columns,
          graphDetail
        )
      );
    }
    if (type === "preview") {
      let twoMonthsDuration = getCustomizedDate(6, "Days");
      let defaultDuration = {
        from:
          moment(twoMonthsDuration?.date[0]).format("YYYY/MM/DD") +
          " " +
          twoMonthsDuration?.time?.startTime,
        to:
          moment(twoMonthsDuration?.date[1]).format("YYYY/MM/DD") +
          " " +
          twoMonthsDuration?.time?.endTime,
      };
      dispatch(setPreviewBrands(selectLogicalBrandValue[type]?.data?.columns));
      let graphObject = preview_metadata
        ? {
            ...preview_metadata,
          }
        : {};

      graphObject.brands = selectLogicalBrandValue[type]?.data?.columns;
      graphObject.start_date = previewDate?.from
        ? previewDate?.from
        : defaultDuration?.from;
      graphObject.end_date = previewDate?.to
        ? previewDate?.to
        : defaultDuration?.to;
      graphObject.isBrandModified = true;
      graphObject.isNetworkChartV2 =
        graphObject?.chart?.chart_type === "network-graph-v2" ? true : false;
      graphObject.isWidgetPreview = true;
      // graphObject.ticket = graphObject?.data_source === "ticket" ? true : false;
      // graphObject.campaign =
      //   graphObject?.data_source === "campaign" ? true : false;
      // graphObject.feedback =
      //   graphObject?.data_source === "feedback" ? true : false;
      // graphObject.nps = graphObject?.data_source === "nps" ? true : false;
      // graphObject.page = graphObject?.data_source === "page" ? true : false;

      graphConditionConfig?.[`data-source`]?.includes(graphObject?.data_source)
        ? dispatch(
            setPageChart(
              authParams,
              graphObject,
              null,
              preview_metadata?.quick_filter
                ? preview_metadata?.quick_filter
                : []
            )
          )
        : dispatch(
            setWidgetMakerGraphData(
              authParams,
              graphObject,
              null,
              preview_metadata?.quick_filter
                ? preview_metadata?.quick_filter
                : []
            )
          );
    }
    if (type === "widgetMaker") {
      let y_series_flag = getWidgetMakerFlag(widgetGraphConfig, wm_api_flag);
      let updateWidgetGraphConfig = { ...widgetGraphConfig };
      if (
        !updateWidgetGraphConfig?.breakdown_by?.[0]?.attribute &&
        updateWidgetGraphConfig?.chart_settings &&
        supportedBenchmarkTraceChartTypes?.includes(
          updateWidgetGraphConfig?.chart_type
        )
      ) {
        let widgetMakerBrands = getWidgetMakerBrands({
          widgetGraphConfig,
          brandlogicalgroup,
          brands,
        });

        let previousSelectedBrands = widgetMakerBrands?.length
          ? widgetMakerBrands
          : null;
        let previousSelectedBrandsIsCompetitor =
          previousSelectedBrands && previousSelectedBrands?.[0]?.competitor
            ? true
            : false;
        if (
          selectLogicalBrandValue[type]?.data?.columns &&
          selectLogicalBrandValue[type]?.data?.columns[0]?.competitor &&
          // Here check with peack and valley , so both will not overllaped in chart setting
          (updateWidgetGraphConfig?.chart_settings?.show_peak ||
          updateWidgetGraphConfig?.chart_settings?.show_valley
            ? !supportedChartTypesForPeakAndValley?.includes(
                updateWidgetGraphConfig?.chart_type
              )
            : true)
        ) {
          if (
            !updateWidgetGraphConfig?.chart_settings?.benchmark_line &&
            !previousSelectedBrandsIsCompetitor // Do not reset the settings if a competitor brand has already been selected.
          ) {
            callNotification("Benchmark settings have been reset.", "info");
            updateWidgetGraphConfig.chart_settings.benchmark_line = true;
            updateWidgetGraphConfig.chart_settings.group_line_agg = "avg";
            updateWidgetGraphConfig.chart_settings.benchmark_static_value =
              null;
          }
        } else {
          if (
            updateWidgetGraphConfig?.chart_settings?.benchmark_line &&
            previousSelectedBrandsIsCompetitor // Reset the settings if a competitor brand has already been selected.
          ) {
            callNotification("Benchmark settings have been reset.", "info");
            updateWidgetGraphConfig.chart_settings.benchmark_line = false;
            updateWidgetGraphConfig.chart_settings.group_line_agg = null;
            updateWidgetGraphConfig.chart_settings.benchmark_static_value =
              null;
          }
        }
      } else if (updateWidgetGraphConfig?.chart_settings) {
        if (updateWidgetGraphConfig?.chart_settings?.benchmark_line) {
          // callNotification("Benchmark settings have been reset.", "info");
          updateWidgetGraphConfig.chart_settings.benchmark_line = false;
          updateWidgetGraphConfig.chart_settings.group_line_agg = null;
          updateWidgetGraphConfig.chart_settings.benchmark_static_value = null;
        }
      }
      if (!y_series_flag?.flag) {
        if (
          selectLogicalBrandValue[type]?.data?.columns &&
          selectLogicalBrandValue[type]?.data?.columns[0]?.competitor
        ) {
          updateWidgetGraphConfig.brands =
            selectLogicalBrandValue[type]?.data?.columns;
          if (!widgetGraphConfig?.x_axis?.attribute) {
            dispatch(
              setY_attribute({
                ...updateWidgetGraphConfig,
                x_axis: {
                  attribute: "BrandName",
                  trace_name: All_WM_attributes["BrandName"],
                  date_part: null,
                  sort_order: "desc",
                  x_limit: null,
                },
                [`y_axis`]: {
                  [`y_series_1`]: {
                    attribute: "tagid",
                    aggregation: "COUNT",
                    trace_name: All_WM_attributes["tagid"],
                  },
                },
                [`y_axis_settings`]: [
                  ...updateWidgetGraphConfig[`y_axis_settings`],
                  {
                    show_as:
                      updateWidgetGraphConfig?.y_axis_settings?.length === 0
                        ? "bar"
                        : "line",
                    y_axis_map_at:
                      updateWidgetGraphConfig?.y_axis_settings?.length === 0
                        ? 0
                        : 1,
                    y_axis_scale: "linear",
                    color_pattern_code: 1,
                    key: uuid(),
                  },
                ],
                deep_dive_on: null,
              })
            );
          } else {
            dispatch(
              setWidgetBrands(
                selectLogicalBrandValue[type]?.data?.columns,
                updateWidgetGraphConfig
              )
            );
          }
        } else {
          dispatch(
            setWidgetBrands(
              selectLogicalBrandValue[type]?.data?.columns,
              updateWidgetGraphConfig
            )
          );
        }
      } else {
        resetState();
        getEmptyFieldNotification();
      }
    }
    if (type === "CommandCenter") {
      if (screen?.quick_filter && screen?.quick_filter === "CampaignID") {
        let previousSelectedBrands = screen?.brands?.columns?.length
          ? screen?.brands?.columns
          : screen?.brands;
        let selectedBrands = selectLogicalBrandValue[type]?.data;
        let currentSelectedBrands = selectedBrands?.columns?.length
          ? selectedBrands?.columns
          : selectedBrands;
        if (
          (previousSelectedBrands?.[0]?.name && currentSelectedBrands?.[0]?.name
            ? previousSelectedBrands?.[0]?.name !==
              currentSelectedBrands?.[0]?.name
            : previousSelectedBrands?.[0]?.brand_id &&
              currentSelectedBrands?.[0]?.brand_id
            ? previousSelectedBrands?.[0]?.brand_id !==
              currentSelectedBrands?.[0]?.brand_id
            : previousSelectedBrands?.[0]?.name &&
              currentSelectedBrands?.[0]?.brand_id
            ? previousSelectedBrands?.[0]?.name !==
              currentSelectedBrands?.[0]?.brand_id
            : previousSelectedBrands?.[0]?.brand_id &&
              currentSelectedBrands?.[0]?.name
            ? previousSelectedBrands?.[0]?.brand_id !==
              currentSelectedBrands?.[0]?.name
            : false) ||
          !screen?.profiles ||
          screen?.profiles?.length === 0
        ) {
          let screenObject = {
            selectBrands: selectLogicalBrandValue[type]?.data,
            brands: brands,
            authParams: authParams,
            singleBrands: brands,
            competitorBrands: competitorBrands,
            graphConditionConfig: graphConditionConfig,
            temporary_words: temporary_words,
          };

          let screenData = {
            ...screen,
            hidden_filter: screen?.hidden_filter,
            quick_filter: screen?.quick_filter,
            saved_filters: screen?.saved_filters,
            isBrandModified: selectLogicalBrandValue[type]?.data
              ? true
              : screen?.brands
              ? true
              : false,
            brands: selectLogicalBrandValue[type]?.data
              ? selectLogicalBrandValue[type]?.data?.columns
              : screen?.brands
              ? screen?.brands?.columns
                ? screen?.brands?.columns
                : screen?.brands
              : screenObject?.brands,
            start_date: screen?.duration ? screen?.duration?.from : null,
            end_date: screen?.duration ? screen?.duration?.to : null,
            template_id: screen?.screen_id,
            predefined: screen?.predefined,
            template_type: screen?.screen_type,
            competition_aggregation: screen?.competition_aggregation,
          };

          dispatch(
            setScreenProfileList(
              authParams,
              screenData,
              screenObject,
              "global_brands"
            )
          );
        } else {
          if (
            screen?.selected_quick_profile &&
            screen?.profiles &&
            Array.isArray(screen?.profiles)
          ) {
            dispatch(
              setSelectProfileId(
                screen?.selected_quick_profile?.name
                  ? screen?.selected_quick_profile?.name
                  : null
              )
            );
            dispatch(
              setChannelImage(
                screen?.selected_quick_profile?.channel
                  ? screen?.selected_quick_profile?.channel
                  : null
              )
            );
            dispatch(
              setProfileImage(
                screen?.selected_quick_profile?.profile_icon_url
                  ? screen?.selected_quick_profile?.profile_icon_url
                  : null
              )
            );
            dispatch(
              setCampaignProfileList(
                screen?.profiles?.length ? [...screen?.profiles] : []
              )
            );
            dispatch(
              setCampaignQuickProfile({ ...screen?.selected_quick_profile })
            );
          } else {
            dispatch(setSelectProfileId(null));
            dispatch(setChannelImage(null));
            dispatch(setProfileImage(null));
            dispatch(setCampaignProfileList(null));
            dispatch(setCampaignQuickProfile(null));
          }
        }
        dispatch(setOpenCampaignPopup(true));
      } else {
        // console.log(
        //   "selectLogicalBrandValue[type]?.data : ",
        //   selectLogicalBrandValue[type]?.data
        // );

        dispatch(setBrandsInScreen(selectLogicalBrandValue[type]?.data));
        dispatch(setScreenRefreshEvent(false));
        dispatch(setClearAllScreenWidgetGraphData());
        // Reset Category screen filters
        if (authParams?.screen_id === "000-000-552") {
          let updatedFilters = [];
          dispatch(setCategoryScreenFilters(updatedFilters));
        }
      }
    }
    if (type === "CommandCenterCampaign") {
      let screenObject = {
        selectBrands: selectLogicalBrandValue[type]?.data,
        brands: brands,
        authParams: authParams,
        singleBrands: brands,
        competitorBrands: competitorBrands,
        graphConditionConfig: graphConditionConfig,
        temporary_words: temporary_words,
      };

      let screenData = {
        ...screen,
        hidden_filter: screen?.hidden_filter,
        quick_filter: screen?.quick_filter,
        saved_filters: screen?.saved_filters,
        isBrandModified: selectLogicalBrandValue[type]?.data
          ? true
          : screen?.brands
          ? true
          : false,
        brands: selectLogicalBrandValue[type]?.data
          ? selectLogicalBrandValue[type]?.data?.columns
          : screen?.brands
          ? screen?.brands?.columns
            ? screen?.brands?.columns
            : screen?.brands
          : screenObject?.brands,
        start_date: screen?.duration ? screen?.duration?.from : null,
        end_date: screen?.duration ? screen?.duration?.to : null,
        template_id: screen?.screen_id,
        predefined: screen?.predefined,
        template_type: screen?.screen_type,
        competition_aggregation: screen?.competition_aggregation,
      };

      dispatch(
        setScreenProfileList(
          authParams,
          screenData,
          screenObject,
          "global_brands"
        )
      );
    }

    setVisible(value);
    setVisibleForBrandGroupTooltip({
      visible: false,
      index: -1,
      brandGroup: "",
    });
    setVisibleForBrandGroupPopover({
      visible: false,
      index: -1,
      brandGroup: "",
    });
  };

  const handleClear = (value) => {
    if (type === "dashboard_section" && editPanelInfo) {
      let updatecheckedValue = { ...logicalBrandCheckedItems };
      let updateselectValue = { ...selectLogicalBrandValue };
      updatecheckedValue[type].data = {}; //to clear all data
      dispatch(setLogicalBrandCheckedItems(updatecheckedValue));
      updateselectValue[type].data = {
        columns: [],
        attribute: "BrandID",
        type: "varchar",
      };
      dispatch(setSelectLogicalBrandValue(updateselectValue));

      let index = getPaneIndex(panes, activeKey);
      let section_id =
        panes[index]?.sections[editPanelInfo?.section_index].section_id;
      let brandFilters = null;

      let paneObject = {
        index: index,
        brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
        panes: panes,
        activeKey: activeKey,
        section_id: section_id,
        brandFilters: brandFilters,
        type: "dashboard_section",
        brand_selected: true,
      };

      dispatch(setDashboardBrandObj(paneObject));
      dispatch(
        setClearBrandAndDuration({
          ...clearBrandAndDuration,
          sectionLevelBrand: true,
        })
      );
    }
    if (type === "dashboard_widget" && editPanelInfo) {
      let updatecheckedValue = { ...logicalBrandCheckedItems };
      let updateselectValue = { ...selectLogicalBrandValue };
      updatecheckedValue[type].data = {}; //to clear all data
      dispatch(setLogicalBrandCheckedItems(updatecheckedValue));
      updateselectValue[type].data = {
        columns: [],
        attribute: "BrandID",
        type: "varchar",
      };
      dispatch(setSelectLogicalBrandValue(updateselectValue));
      let index = getPaneIndex(panes, activeKey);
      let section_id = panes[index]?.sections
        ? panes[index]?.sections[editPanelInfo?.section_index].section_id
        : panes[index]?.section && panes[index]?.section[0].section_id;
      let widget_id = panes[index]?.sections
        ? panes[index]?.sections[editPanelInfo?.section_index].widgets[
            editPanelInfo?.widget_index
          ].widget_id
        : panes[index]?.section &&
          panes[index]?.section[0].widgets[editPanelInfo?.widget_index]
            .widget_id;
      let brandFilters = null;

      let paneObject = {
        index: index,
        brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
        panes: panes,
        activeKey: activeKey,
        section_id: section_id,
        widget_index: editPanelInfo?.widget_index,
        widget_id: widget_id,
        brandFilters: brandFilters,
        type: "dashboard_widget",
      };
      dispatch(setDashboardBrandObj(paneObject));
      dispatch(
        setClearBrandAndDuration({
          ...clearBrandAndDuration,
          widgetLevelBrand: true,
        })
      );

      let widget_metadata = panes[index]?.sections
        ? panes[index]?.sections[editPanelInfo?.section_index].widgets[
            editPanelInfo?.widget_index
          ]
        : panes[index]?.section &&
          panes[index]?.section[0].widgets[editPanelInfo?.widget_index];

      if (widget_metadata?.profile_filters_flag) {
        // To clear profile filters in widget
        dashboardBrandObj &&
          dashboardBrandObj?.brandFilters &&
          dispatch(
            updateDashboardWidgetProfileFilters(
              panes,
              index,
              editPanelInfo?.section_index,
              editPanelInfo?.widget_index
            )
          );
        dispatch(setFilterObject(selectedSection, false));
        if (selectedSection?.is_locked) {
          callNotification("Selected widget is unlocked", "success");
        }
      }
    }
    if (type === "template_section") {
      if (
        !Section?.[selectedSection?.section_index]?.brandFilters?.columns
          ?.length
      ) {
        dispatch(setIsWidgetEdit(false));
        dispatch(setIsNetworkWidgetSettingEdit(false));
        dispatch(setNetworkWidgetSettingObject(null));
        return;
      }
      let updatecheckedValue = { ...logicalBrandCheckedItems };
      let updateselectValue = { ...selectLogicalBrandValue };
      updatecheckedValue[type].data = {}; //to clear all data
      dispatch(setLogicalBrandCheckedItems(updatecheckedValue));
      updateselectValue[type].data = {
        columns: [],
        attribute: "BrandID",
        type: "varchar",
      };
      dispatch(setSelectLogicalBrandValue(updateselectValue));

      let templateObj1 = {
        section: Section,
        templateDetails: templateDetails,
        section_index: editPanelInfo?.section_index,
        authParams: authParams,
        brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
        selectBrands: null,
      };
      dispatch(setTemplateSectionBrands(templateObj1));
      let global = templateDetails?.templateFilters
        ? templateDetails?.templateFilters
        : [];

      let global_brands = templateDetails?.templateBrands
        ? templateDetails?.templateBrands
        : null;
      let global_duration = templateDetails?.templateDuration
        ? templateDetails?.templateDuration
        : null;
      let comBrand = global_brands?.columns?.[0]?.competitor
        ? global_brands?.columns?.[0]
        : global_brands?.[0]?.competitor
        ? global_brands?.[0]
        : global_brands?.competitor
        ? global_brands
        : null;

      if (selectedSection?.is_locked && comBrand) {
        let res = null;
        let newSection = null;
        let currectSection = Section?.[editPanelInfo?.section_index];
        res = checkForDuplicateWidgets([currectSection]);
        if (res?.parentExists) {
          let filterSectionData = getFilterDuplicateWidgets([currectSection]);
          if (filterSectionData !== null) {
            let newBrandList = [];
            newBrandList.push({
              brand_id: comBrand?.name,
              brand_name: comBrand?.brand_name,
              brand_friendly_name: comBrand?.brand_friendly_name,
            });
            comBrand?.competitorList?.forEach((competitorBrand) => {
              newBrandList.push(competitorBrand);
            });
            newSection = splitSectionWidgets(
              filterSectionData,
              type,
              newBrandList
            );
          }
        } else if (res?.duplicateExists) {
          let newBrandList = [];
          newBrandList.push({
            brand_id: comBrand?.name,
            brand_name: comBrand?.brand_name,
            brand_friendly_name: comBrand?.brand_friendly_name,
          });
          comBrand?.competitorList?.forEach((competitorBrand) => {
            newBrandList.push(competitorBrand);
          });
          newSection = splitSectionWidgets(
            [currectSection],
            type,
            newBrandList
          );
        }
        if (res && (res?.duplicateExists || res?.parentExists) && newSection) {
          Section[editPanelInfo?.section_index] = newSection?.[0];
        }
      }

      let templateObj = {
        section: Section,
        templateDetails: templateDetails,
        section_index: selectedSection?.section_index,
        authParams: authParams,
        brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
        global_brands: global_brands,
        filters: Section[selectedSection?.section_index]?.onlyFilters,
        duration: global_duration,
        is_locked: selectedSection?.is_locked,
        brandFilters: templateObj1?.selectBrands
          ? templateObj1?.selectBrands
          : null,
        dateFilters: Section[selectedSection?.section_index]?.dateFilters,
        clear: false,
        profile_filters_list: [],
      };
      dispatch(
        setTemplateSectionFilter(templateObj, false, {
          ...clearBrandAndDuration,
          sectionLevelBrand: true,
        })
      );

      let obj = {
        type: "template_section",
        filters: global,
        section: Section,
        brands: templateDetails?.brands
          ? templateDetails?.brands
          : brandlogicalgroup?.length > 0
          ? brandlogicalgroup
          : brands,
        authParams: authParams,
        duration: global_duration,
        currentFilter: value ? value : [],
        graphConditionConfig: graphConditionConfig,
      };
      dispatch(setIsWidgetEdit(false));
      dispatch(setIsNetworkWidgetSettingEdit(false));
      dispatch(setNetworkWidgetSettingObject(null));
      dispatch(setTemplateFilter(obj, templateObj));

      // Clear profile_filters of all widgets on change of global brands
      dispatch(setClearProfileFiltersSection(Section));
    }
    if (type === "template_widget") {
      let widget_metadata =
        editPanelInfo?.section_index >= 0
          ? Section?.[editPanelInfo?.section_index]?.data?.[
              editPanelInfo?.widget_index
            ]
          : Section?.[0]?.data?.[editPanelInfo?.widget_index];
      if (!widget_metadata?.brandFilters?.columns?.length) {
        dispatch(setIsWidgetEdit(false));
        dispatch(setIsNetworkWidgetSettingEdit(false));
        dispatch(setNetworkWidgetSettingObject(null));
        return;
      }
      let updatecheckedValue = { ...logicalBrandCheckedItems };
      let updateselectValue = { ...selectLogicalBrandValue };
      updatecheckedValue[type].data = {}; //to clear all data
      dispatch(setLogicalBrandCheckedItems(updatecheckedValue));
      updateselectValue[type].data = {
        columns: [],
        attribute: "BrandID",
        type: "varchar",
      };
      dispatch(setSelectLogicalBrandValue(updateselectValue));

      let templateObj1 = {
        section: Section,
        templateDetails: templateDetails,
        section_index: editPanelInfo?.section_index,
        authParams: authParams,
        widget_index: editPanelInfo?.widget_index,
        brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
        selectBrands: null,
      };
      dispatch(setTemplateWidgetBrands(templateObj1));

      let global = templateDetails?.templateFilters
        ? templateDetails?.templateFilters
        : [];

      let global_brands = templateDetails?.templateBrands
        ? templateDetails?.templateBrands
        : null;

      let global_duration = templateDetails?.templateDuration
        ? templateDetails?.templateDuration
        : null;

      let section_profile_filters_list =
        editPanelInfo?.section_index >= 0
          ? Section?.[editPanelInfo?.section_index]?.profile_filters_list
          : Section?.[0]?.profile_filters_list;

      let widget_profile_filters_list =
        editPanelInfo?.section_index >= 0
          ? Section?.[editPanelInfo?.section_index]?.data?.[
              editPanelInfo?.widget_index
            ]?.profile_filters_list
          : Section?.[0]?.data?.[editPanelInfo?.widget_index]
              ?.profile_filters_list;

      let res = null;
      let newSection = deepCopy(Section);
      let updatedSection = null;
      let currectSection = deepCopy(Section?.[editPanelInfo?.section_index]);
      let forParticularSection = {
        section_index: selectedSection?.section_index
          ? selectedSection?.section_index
          : 0,
        section_id: currectSection?.id,
        widget_id: selectedSection?.id,
        widget_index: selectedSection?.widget_index,
      };
      // if dupliates widget exists and global brand is competitor then need split again
      let secLockedOnBrand =
        currectSection?.is_locked &&
        currectSection?.brands &&
        currectSection?.brands?.length > 0 &&
        (currectSection?.brands?.[0]?.columns?.length > 0
          ? !currectSection?.brands?.[0]?.columns?.[0]?.competitor
          : !currectSection?.brands?.[0]?.competitor);
      let comBrandtypeExists =
        currectSection?.comp_brand_type === false ||
        currectSection?.comp_brand_type === true
          ? true
          : false;
      let currectWidget =
        currectSection?.data && currectSection?.data?.length > 0
          ? currectSection?.data?.[selectedSection?.widget_index]
          : currectSection?.widgets?.[selectedSection?.widget_index];
      let widgetLockedOnBrand =
        selectedSection?.is_locked &&
        currectWidget?.brands?.length > 0 &&
        (currectWidget?.brands?.[0]?.columns?.length > 0
          ? !currectWidget?.brands?.[0]?.columns?.[0]?.competitor
          : !currectWidget?.brands?.[0]?.competitor);
      let comBrand = global_brands?.columns?.[0]?.competitor
        ? global_brands?.columns?.[0]
        : global_brands?.[0]?.competitor
        ? global_brands?.[0]
        : global_brands?.competitor
        ? global_brands
        : null;
      if (
        comBrand &&
        !secLockedOnBrand &&
        !comBrandtypeExists &&
        !widgetLockedOnBrand &&
        currectWidget?.chart &&
        currectWidget?.chart?.["chart_settings"]["duplicate_for_brands"]
      ) {
        res = checkForDuplicateWidgets(newSection, forParticularSection);
        let filterSectionData;
        if (res?.parentExists) {
          let filterSectionData = getFilterDuplicateWidgets(
            newSection,
            forParticularSection
          );
          if (filterSectionData !== null) {
            let iOfW = filterSectionData?.[forParticularSection?.section_index]
              ?.data?.length
              ? filterSectionData?.[
                  forParticularSection?.section_index
                ]?.data?.findIndex(
                  (el) => el?.widget_id === forParticularSection?.widget_id
                )
              : filterSectionData?.[
                  forParticularSection?.section_index
                ]?.widgets?.findIndex(
                  (el) => el?.widget_id === forParticularSection?.widget_id
                );
            if (iOfW !== -1) {
              // if (
              //   filterSectionData?.[forParticularSection?.section_index]?.data
              //     ?.length
              // ) {
              //   filterSectionData[forParticularSection?.section_index].data[
              //     iOfW
              //   ] = currectWidget; // need to assign updated widget metadata
              // } else {
              //   filterSectionData[forParticularSection?.section_index].widgets[
              //     iOfW
              //   ] = currectWidget; // need to assign updated widget metadata
              // }
            }
            let newBrandList = [];
            newBrandList.push({
              brand_id: comBrand?.name,
              brand_name: comBrand?.brand_name,
              brand_friendly_name: comBrand?.brand_friendly_name,
            });
            comBrand?.competitorList?.forEach((competitorBrand) => {
              newBrandList.push(competitorBrand);
            });

            // updatedSection = splitSectionWidgets(
            //   filterSectionData,
            //   newBrandList,
            //   brands
            // );
            updatedSection = splitSectionWidgets(
              filterSectionData,
              type,
              newBrandList
            );
          }
        } else if (res?.duplicateExists) {
          let newBrandList = [];
          newBrandList.push({
            brand_id: comBrand?.name,
            brand_name: comBrand?.brand_name,
            brand_friendly_name: comBrand?.brand_friendly_name,
          });
          comBrand?.competitorList?.forEach((competitorBrand) => {
            newBrandList.push(competitorBrand);
          });
          updatedSection = splitSectionWidgets(newSection, type, newBrandList);
          // updatedSection = splitSectionWidgets(
          //   [currectSection],
          //   newBrandList,
          //   brands
          // );
        }
      } else if (
        currectWidget?.chart &&
        currectWidget?.chart?.["chart_settings"]["duplicate_for_brands"]
      ) {
        res = checkForDuplicateWidgets(newSection, forParticularSection);
        let filterSectionData;
        if (res?.parentExists) {
          let filterSectionData = getFilterDuplicateWidgets(
            newSection,
            forParticularSection
          );
          if (filterSectionData !== null) {
            let iOfW = filterSectionData?.[forParticularSection?.section_index]
              ?.data?.length
              ? filterSectionData?.[
                  forParticularSection?.section_index
                ]?.data?.findIndex(
                  (el) => el?.widget_id === forParticularSection?.widget_id
                )
              : filterSectionData?.[
                  forParticularSection?.section_index
                ]?.widgets?.findIndex(
                  (el) => el?.widget_id === forParticularSection?.widget_id
                );
            if (iOfW !== -1) {
              // if (
              //   filterSectionData?.[forParticularSection?.section_index]?.data
              //     ?.length
              // ) {
              //   filterSectionData[forParticularSection?.section_index].data[
              //     iOfW
              //   ] = currectWidget; // need to assign updated widget metadata
              // } else {
              //   filterSectionData[forParticularSection?.section_index].widgets[
              //     iOfW
              //   ] = currectWidget; // need to assign updated widget metadata
              // }
            }
            updatedSection = filterSectionData;
          }
        }
      }
      let needToBeUpdateSectionAllWidgetsWithId = null;
      if (
        res &&
        (res?.duplicateExists || res?.parentExists) &&
        updatedSection
      ) {
        Section[editPanelInfo?.section_index] =
          updatedSection?.[editPanelInfo?.section_index];
        needToBeUpdateSectionAllWidgetsWithId = {
          ...forParticularSection,
        };
      }

      let templateObj = {
        section: Section,
        templateDetails: templateDetails,
        section_index: selectedSection?.section_index,
        widget_index: selectedSection?.widget_index,
        authParams: authParams,
        global_brands: global_brands,
        brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
        filters: selectedSection?.section_index
          ? Section[selectedSection?.section_index]?.data[
              selectedSection?.widget_index
            ]?.onlyFilters
          : Section[0]?.data[selectedSection?.widget_index]?.onlyFilters,
        duration: global_duration,
        is_locked: widget_metadata?.profile_filters_flag
          ? false
          : selectedSection?.is_locked,
        brandFilters: templateObj1?.selectBrands
          ? templateObj1?.selectBrands
          : null,
        dateFilters: selectedSection?.section_index
          ? Section[selectedSection?.section_index]?.data[
              selectedSection?.widget_index
            ]?.dateFilters
          : Section[0]?.data[selectedSection?.widget_index]?.dateFilters,
        clear: false,
        span_check:
          templateDateFilterObj?.templateObj?.durationObj ||
          templateObj1?.selectBrands
            ? true
            : false,
        profile_filters: null,
        profile_filters_list:
          section_profile_filters_list?.length > 0
            ? section_profile_filters_list
            : profileFilterList,
        profile_filters_flag: widget_metadata?.profile_filters_flag,
      };

      dispatch(
        setTemplateWidgetFilter(
          templateObj,
          false,
          {
            ...clearBrandAndDuration,
            widgetLevelBrand: true,
          },
          needToBeUpdateSectionAllWidgetsWithId
        )
      );

      let obj = {
        type: "template_widget",
        filters: global,
        section: templateObj1?.section ? templateObj1?.section : Section,
        brands: templateDetails?.brands
          ? templateDetails?.brands
          : brandlogicalgroup?.length > 0
          ? brandlogicalgroup
          : brands,
        authParams: authParams,
        duration: global_duration,
        graphConditionConfig: graphConditionConfig,
      };
      dispatch(setIsWidgetEdit(false));
      dispatch(setIsNetworkWidgetSettingEdit(false));
      dispatch(setNetworkWidgetSettingObject(null));
      dispatch(setTemplateFilter(obj, templateObj));

      // in edit dashboard, profile filters, to clear is_locked of section
      if (widget_metadata?.profile_filters_flag) {
        dispatch(setFilterObject(selectedSection, false));
        if (selectedSection?.is_locked) {
          callNotification("Selected widget is unlocked", "success");
        }

        // dispatch(setTemplateWidgetFilter(templateObj, true));

        dispatch(
          setTemplateWidgetFilter(
            templateObj,
            false,
            {
              ...clearBrandAndDuration,
              widgetLevelBrand: true,
            },
            needToBeUpdateSectionAllWidgetsWithId
          )
        );
      }
    }
    if (type === "advance_settings") {
      let template_brands = templateDetails?.advance_brands;
      if (template_brands?.length > 0 || template_brands?.columns?.length > 0) {
        let updatecheckedValue = { ...logicalBrandCheckedItems };
        let updateselectValue = { ...selectLogicalBrandValue };
        updatecheckedValue[type].data = {}; //to clear all data
        dispatch(setLogicalBrandCheckedItems(updatecheckedValue));
        updateselectValue[type].data = {
          columns: [],
          attribute: "BrandID",
          type: "varchar",
        };
        dispatch(setSelectLogicalBrandValue(updateselectValue));
      }
      dispatch(
        setTemplateDetails(templateDetails, {
          advance_brands: [],
        })
      );
    }

    setVisible(value);
  };
  const handleCancel = (value) => {
    if (!value) {
      setVisibleForBrandGroupTooltip({
        visible: false,
        index: -1,
        brandGroup: "",
      });
      setVisibleForBrandGroupPopover({
        visible: false,
        index: -1,
        brandGroup: "",
      });
    }
    setVisible(value);
    setSearch();
    if (type !== "share_dashboard_global") {
      setBrandValue(brands);
      setBrandLogicalGroupValue(brandlogicalgroup);
      setcompetitorBrandsValue(competitorBrands);
    } else {
      // console.log(
      //   "⚡ Skipping brand state override for share_dashboard_global"
      // );
      // For share_dashboard_global, reset to the original filtered values
      setFilteredBrandLists(sharedDashboardBrands, false); // false for no debug logs
    }
    resetState();
  };

  const handleSearch = (e) => {
    if (String(e.target.value).trim() !== "") {
      let filterBrands = [];
      let filterCompetitorBrands = [];
      let filterBrandLogicalGroup = [];

      // For share_dashboard_global, search within the original filtered shared dashboard lists
      if (type === "share_dashboard_global" && sharedDashboardBrands) {
        // Get the original filtered lists from shared dashboard data
        const originalFilteredBrandGroups = getFilteredBrandGroups(
          sharedDashboardBrands
        );
        const originalFilteredBrands = getFilteredBrands(sharedDashboardBrands);
        // Get filtered competitor brands from shared dashboard data
        const originalFilteredCompetitorBrands = getFilteredCompetitorBrands(
          sharedDashboardBrands
        );

        originalFilteredBrands?.forEach((el) => {
          if (
            String(el?.brand_friendly_name)
              ?.trim()
              ?.toLowerCase()
              ?.includes(String(e?.target?.value)?.trim()?.toLowerCase())
          ) {
            filterBrands = [...filterBrands, { ...el }];
          }
        });
        originalFilteredBrandGroups?.forEach((el) => {
          if (
            String(el?.brand_group_name)
              ?.trim()
              ?.toLowerCase()
              ?.includes(String(e?.target?.value)?.trim()?.toLowerCase())
          ) {
            filterBrandLogicalGroup = [...filterBrandLogicalGroup, { ...el }];
          }
        });
        originalFilteredCompetitorBrands?.forEach((el) => {
          if (
            String(el?.brand_friendly_name)
              ?.trim()
              ?.toLowerCase()
              ?.includes(String(e?.target?.value)?.trim()?.toLowerCase())
          ) {
            filterCompetitorBrands = [...filterCompetitorBrands, { ...el }];
          }
        });
      } else {
        // For other types, search in the original full lists
        brands?.forEach((el) => {
          if (
            String(el?.brand_friendly_name)
              ?.trim()
              ?.toLowerCase()
              ?.includes(String(e?.target?.value)?.trim()?.toLowerCase())
          ) {
            filterBrands = [...filterBrands, { ...el }];
          }
        });
        brandlogicalgroup?.forEach((el) => {
          if (
            String(el?.brand_group_name)
              ?.trim()
              ?.toLowerCase()
              ?.includes(String(e?.target?.value)?.trim()?.toLowerCase())
          ) {
            filterBrandLogicalGroup = [...filterBrandLogicalGroup, { ...el }];
          }
        });

        competitorBrands?.forEach((el) => {
          if (
            String(el?.brand_friendly_name)
              ?.trim()
              ?.toLowerCase()
              ?.includes(String(e?.target?.value)?.trim()?.toLowerCase())
          ) {
            filterCompetitorBrands = [...filterCompetitorBrands, { ...el }];
          }
        });
      }

      setSearch(e?.target?.value);
      setcompetitorBrandsValue(filterCompetitorBrands);
      setBrandValue(filterBrands);
      setBrandLogicalGroupValue(filterBrandLogicalGroup);
    } else {
      setSearch(e?.target?.value);
      if (type !== "share_dashboard_global") {
        setBrandValue(brands);
        setBrandLogicalGroupValue(brandlogicalgroup);
        setcompetitorBrandsValue(competitorBrands);
      } else {
        // For share_dashboard_global, reset to the original filtered values
        // console.log(
        //   "⚡ handleSearch: Resetting to original filtered values for share_dashboard_global"
        // );
        setFilteredBrandLists(sharedDashboardBrands, false); // false for no debug logs
      }
    }
  };
  // For share_dashboard_global, determine which sections should be visible based on selected data
  const shouldShowLogicalGroups =
    type === "share_dashboard_global"
      ? sharedDashboardBrands?.selected_brand_groups?.length > 0
      : true;

  const shouldShowBrands =
    type === "share_dashboard_global"
      ? sharedDashboardBrands?.selected_brand_ids?.length > 0 &&
        !(
          Array.isArray(sharedDashboardBrands?.selected_comp_brand_ids) &&
          sharedDashboardBrands?.selected_comp_brand_ids?.length > 0
        )
      : true;

  const shouldShowCompetitorList =
    type === "share_dashboard_global"
      ? Array.isArray(sharedDashboardBrands?.selected_comp_brand_ids) &&
        sharedDashboardBrands?.selected_comp_brand_ids?.length > 0
      : true;

  // console.log(
  //   "BrandsLogicalGroup selectLogicalBrandValue[type]?.data : ",
  //   selectLogicalBrandValue[type]?.data,
  //   "logicalBrandCheckedItems[type] : ",
  //   logicalBrandCheckedItems[type],
  //   "sharedDashboardBrands : ",
  //   sharedDashboardBrands
  // );
  return (
    <Popover
      content={
        <>
          <div
            className="custom_scroll p-15"
            style={{
              maxHeight: type === "share_modal" ? "18rem" : "22rem",
              overflow: "auto",
              minWidth: "25rem",
              width: brandTitleContainer?.current?.clientWidth
                ? brandTitleContainer?.current?.clientWidth
                : type === "share_modal"
                ? "55rem"
                : "25rem",
              maxWidth: brandTitleContainer?.current?.clientWidth
                ? brandTitleContainer?.current?.clientWidth
                : type === "dashboard_section" ||
                  type === "dashboard_widget" ||
                  type === "template_section" ||
                  type === "template_widget"
                ? "25rem"
                : type === "share_modal"
                ? "55rem"
                : "25rem",
            }}
          >
            {!(
              shouldShowCompetitorList && type === "share_dashboard_global"
            ) ? (
              <Input
                className="border-radius-4 border-color mb-3"
                placeholder="Search brands/groups"
                suffix={suffix}
                style={{ height: "3.5rem" }}
                value={search}
                allowClear={true}
                onChange={(e) => handleSearch(e)}
              />
            ) : (
              ""
            )}
            {((type === "advance_settings" &&
              templateDetails?.template_type !== "competition") ||
              type !== "advance_settings") &&
              !quick_filters &&
              // !is_prolific_user &&
              (type === "dashboard_widget" ||
              type === "template_widget" ||
              type === "preview"
                ? widget_metadata?.type === "predefined" &&
                  widget_metadata?.allow_logical_group
                  ? true
                  : widget_metadata?.type === "predefined" &&
                    !widget_metadata?.profile_filters_flag
                  ? false
                  : true
                : true) &&
              shouldShowLogicalGroups && (
                <div
                  className={`portlet-label text-Darkgray mb-1 d-flex  align-items-center justify-content-between `}
                >
                  <span className="font-weight500"> Logical Groups</span>
                  <span
                    className="cursor-pointer text-center"
                    style={{
                      width: "2.2rem",
                      height: "100%",
                      verticalAlign: "middle",
                    }}
                    onClick={() =>
                      setBrandLogicalGroupCollapse(!brandLogicalGroupCollapse)
                    }
                  >
                    <img
                      src={
                        authParams?.theme_type === "1"
                          ? accoArrowWhite
                          : accoArrow
                      }
                      alt="arrow"
                      className="accordionArrow"
                      style={{
                        transform: `rotate(${
                          brandLogicalGroupCollapse ? "0deg" : "180deg"
                        })`,
                        maxWidth: "100%",
                      }}
                    />
                  </span>
                </div>
              )}

            {((type === "advance_settings" &&
              templateDetails?.template_type !== "competition") ||
              type !== "advance_settings") &&
            !quick_filters &&
            // !is_prolific_user &&
            (type === "dashboard_widget" ||
            type === "template_widget" ||
            type === "preview"
              ? widget_metadata?.type === "predefined" &&
                widget_metadata?.allow_logical_group
                ? true
                : widget_metadata?.type === "predefined" &&
                  !widget_metadata?.profile_filters_flag
                ? false
                : true
              : true) &&
            brandLogicalGroupCollapse &&
            shouldShowLogicalGroups &&
            brandLogicalGroupValue?.length > 0
              ? brandLogicalGroupValue?.map((el, i) => {
                  return (
                    <div
                      className="text_regular mb-1"
                      key={`Logicalbrand_list${i}`}
                    >
                      <div className="w-100 d-flex justify-content-between ">
                        <Checkbox
                          onChange={(item) =>
                            handleOnSelectChange(
                              item,
                              el?.brand_group_name,
                              "group",
                              el
                            )
                          }
                          value={el?.brand_group_name}
                          checked={
                            logicalBrandCheckedItems[type]?.data &&
                            logicalBrandCheckedItems[type]?.data[
                              el?.brand_group_name + "_group"
                            ]
                          }
                          style={{
                            display: "inline-flex",
                            lineHeight: "normal",
                            alignItems: "center",
                          }}
                        >
                          {/* <Tooltip
                            title={
                              <div
                                className="custom_scroll p-2 "
                                style={{
                                  maxHeight: "20rem",
                                  overflow: "auto",
                                  maxWidth: "20rem",
                                }}
                              >
                                {el?.brand_list?.map((e, bIndex) => {
                                  return (
                                    <div
                                      style={{
                                        color: "#F5F6F8",
                                        maxHeight: "20rem",
                                        overflow: "auto",
                                      }}
                                      className="mb-1"
                                      key={`Logicalbrand_list${i}TooltipList${bIndex}`}
                                    >
                                      {e?.brand_friendly_name}
                                    </div>
                                  );
                                })}
                              </div>
                            }
                            placement="right"
                          > */}
                          <span className="d-flex align-items-center logical-group-text">
                            <Image
                              src={el?.brand_logo_image || el?.brand_logo}
                              alt="brand logo"
                              style={{
                                width: "2rem",
                                maxHeight: "2rem",
                                borderRadius: "50%",
                                marginRight: "1rem",
                              }}
                              fallback={DefaultBrandLogo}
                              preview={false}
                              //className="border border-color box-shadow"
                            />{" "}
                            {el?.brand_group_name}
                          </span>
                          {/* </Tooltip> */}
                        </Checkbox>
                        {type !== "share_dashboard_global" ? (
                          <Popover
                            key={`Logicalbrand_listPopover${i}`}
                            trigger="click"
                            placement="right"
                            open={
                              visibleForBrandGroupPopover?.brandGroup ===
                                el?.brand_group_name &&
                              visibleForBrandGroupPopover?.index === i &&
                              visibleForBrandGroupPopover?.visible
                            }
                            overlayClassName={
                              authParams?.theme_type === "1"
                                ? "darkTheme"
                                : "lightTheme"
                            }
                            onOpenChange={(e) => {
                              //function to open and close dropdown
                              getBrandListForThisBrandGroup(e, el, i);
                            }}
                            content={
                              <div
                                className="custom_scroll"
                                style={{
                                  minWidth: "16rem",
                                  maxWidth: "20rem",
                                  minHeight: loaderForBrandGroupPopover
                                    ? "6rem"
                                    : "5rem",
                                }}
                              >
                                <div className="text_heading border-bottom pt-1 pb-1 pl-2 pr-2 fontSize-14 font-weight500 d-flex align-items-center justify-content-between">
                                  {el?.brand_group_name}
                                  <CloseOutlined
                                    className="cursor-pointer"
                                    onClick={() => {
                                      getBrandListForThisBrandGroup(
                                        false,
                                        el,
                                        i
                                      );
                                      setVisibleForBrandGroupPopover({
                                        visible: false,
                                        index: i,
                                        brandGroup: el?.brand_group_name,
                                      });
                                    }}
                                  />
                                </div>
                                {Array.isArray(el?.brand_list) &&
                                el?.brand_list?.length ? (
                                  <ul
                                    className="list-group list-group-flush custom_scroll1"
                                    style={{
                                      minHeight: "2rem",
                                      maxHeight: "16rem",
                                      overflow: "auto",
                                    }}
                                  >
                                    <>
                                      {el?.brand_list?.map((e, bIndex) => {
                                        return (
                                          <li
                                            key={`Logicalbrand_list${i}TooltipList${bIndex}`}
                                            className={`list-group-item border-color text-transform__capitalize border-0 text_regular-gray fontSize-14 px-2 ${
                                              parseInt(
                                                el?.brand_list?.length
                                              ) === 1
                                                ? "py-3"
                                                : "py-1"
                                            }`}
                                          >
                                            {e?.brand_friendly_name}
                                          </li>
                                        );
                                      })}
                                    </>
                                  </ul>
                                ) : loaderForBrandGroupPopover ? (
                                  <div className="loader h-100">
                                    <div className="lds-ring">
                                      <div></div>
                                      <div></div>
                                      <div></div>
                                      <div></div>
                                    </div>
                                  </div>
                                ) : (
                                  <>
                                    <div className="text_heading pt-1 pb-1 pl-2 pr-2 fontSize-14 font-weight500">
                                      {"No Brand Lists"}
                                    </div>
                                  </>
                                )}
                              </div>
                            }
                          >
                            <Tooltip
                              open={
                                !(
                                  visibleForBrandGroupPopover?.brandGroup ===
                                    el?.brand_group_name &&
                                  visibleForBrandGroupPopover?.index === i &&
                                  visibleForBrandGroupPopover?.visible
                                ) &&
                                !loaderForBrandGroupPopover &&
                                visibleForBrandGroupTooltip?.brandGroup ===
                                  el?.brand_group_name &&
                                visibleForBrandGroupTooltip?.index === i &&
                                visibleForBrandGroupTooltip?.visible
                              }
                              onOpenChange={(visible) => {
                                handleVisibleChangeOfBrandGroupTooltip(
                                  visible,
                                  el,
                                  i
                                );
                              }}
                              title={"Click to see brand(s)"}
                            >
                              <i
                                className={`fa fa-info-circle cursor-pointer ${
                                  loaderForBrandGroupPopover ||
                                  (visibleForBrandGroupPopover?.brandGroup ===
                                    el?.brand_group_name &&
                                    visibleForBrandGroupPopover?.index === i &&
                                    visibleForBrandGroupPopover?.visible)
                                    ? "disable"
                                    : ""
                                }`}
                                style={{
                                  fontSize: "var(--regular-fonts-Size)",
                                }}
                              />
                            </Tooltip>
                          </Popover>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  );
                })
              : type !== "advance_settings" &&
                !quick_filters &&
                // !is_prolific_user &&
                (type === "dashboard_widget" ||
                type === "template_widget" ||
                type === "preview"
                  ? widget_metadata?.type === "predefined" &&
                    widget_metadata?.allow_logical_group
                    ? true
                    : widget_metadata?.type === "predefined" &&
                      !widget_metadata?.profile_filters_flag
                    ? false
                    : true
                  : true) && (
                  <>
                    {brandLogicalGroupCollapse && shouldShowLogicalGroups && (
                      <span className="font-size12 text-gray">
                        {brandlogicalgroup?.length <= 0
                          ? "No Brand groups"
                          : "No search result found"}
                      </span>
                    )}
                  </>
                )}
            {((type === "advance_settings" &&
              templateDetails?.template_type !== "competition") ||
              type !== "advance_settings") &&
              brandVal &&
              shouldShowBrands && (
                <div
                  className={`"portlet-label text-Darkgray d-flex mb-1 align-items-center justify-content-between `}
                >
                  <span className="font-weight500">Brands</span>
                  <span
                    className="cursor-pointer text-center"
                    style={{
                      width: "2.2rem",
                      height: "100%",
                      verticalAlign: "middle",
                    }}
                    onClick={() => setBrandListCollapse(!brandListCollapse)}
                  >
                    <img
                      src={
                        authParams?.theme_type === "1"
                          ? accoArrowWhite
                          : accoArrow
                      }
                      alt="arrow"
                      className="accordionArrow"
                      style={{
                        transform: `rotate(${
                          brandListCollapse ? "0deg" : "180deg"
                        })`,
                      }}
                    />
                  </span>
                </div>
              )}
            {((type === "advance_settings" &&
              templateDetails?.template_type !== "competition") ||
              type !== "advance_settings") &&
            brandListCollapse &&
            brandVal?.length > 0 &&
            shouldShowBrands ? (
              <div className="text_regular mb-1" key={brandVal?.brand_id}>
                {!search &&
                  !quick_filters &&
                  !templateDetails?.profileInfo &&
                  // !is_prolific_user &&
                  (type === "dashboard_widget" ||
                  type === "template_widget" ||
                  type === "preview"
                    ? widget_metadata?.type === "predefined"
                      ? false
                      : true
                    : true) && (
                    <Checkbox
                      onChange={
                        createWorkSpace
                          ? (item) => handleOnSelectChange(item, true)
                          : (item) => handleOnSelectChange(item)
                      }
                      checked={
                        logicalBrandCheckedItems[type]?.data &&
                        logicalBrandCheckedItems[type]?.data.All
                      }
                      value={"All"}
                    >
                      <img
                        style={{
                          width: "2rem",
                          height: "2rem",
                          borderRadius: "50%",
                          marginRight: "1rem",
                        }}
                        src={DefaultBrandLogo}
                        alt="Default Brand Logo"
                        //className="border border-color box-shadow"
                      />
                      All
                    </Checkbox>
                  )}
              </div>
            ) : (
              ((type === "advance_settings" &&
                templateDetails?.template_type !== "competition") ||
                type !== "advance_settings") &&
              brandListCollapse &&
              shouldShowBrands && (
                <div className="font-size12 text-gray">
                  {brands?.length <= 0
                    ? "No Brand Lists"
                    : "No search result found"}
                </div>
              )
            )}
            {((type === "advance_settings" &&
              templateDetails?.template_type !== "competition") ||
              type !== "advance_settings") &&
              brandListCollapse &&
              shouldShowBrands &&
              brandVal &&
              brandVal?.map((el, i) => {
                return (
                  <div className="text_regular mb-1" key={`brand_list${i}`}>
                    <Checkbox
                      onChange={(item) => handleOnSelectChange(item, el)}
                      value={el?.brand_friendly_name}
                      checked={
                        logicalBrandCheckedItems[type]?.data &&
                        logicalBrandCheckedItems[type]?.data[
                          el?.brand_friendly_name
                        ]
                      }
                      style={{
                        display: "inline-flex",
                        lineHeight: "normal",
                        alignItems: "center",
                      }}
                    >
                      <span className="d-flex align-items-center">
                        <Image
                          style={{
                            width: "2rem",
                            maxHeight: "2rem",
                            borderRadius: "50%",
                            marginRight: "1rem",
                          }}
                          src={el?.brand_logo}
                          fallback={DefaultBrandLogo}
                          preview={false}
                          //className="border border-color box-shadow"
                        />
                        {el?.brand_friendly_name}
                      </span>
                    </Checkbox>
                  </div>
                );
              })}
            {/* competitor */}
            {((type === "widgetMaker" && !isOrmUser) ||
              (type === "share_modal" &&
                !quick_filters &&
                !brandlist_brandgroup_select &&
                !isOrmUser) ||
              (type === "share_dashboard_global" &&
                !quick_filters &&
                !brandlist_brandgroup_select &&
                !isOrmUser) ||
              (type === "global_dashboard" &&
                !quick_filters &&
                !brandlist_brandgroup_select &&
                !isOrmUser) ||
              (type === "CommandCenter" &&
                !quick_filters &&
                !brandlist_brandgroup_select &&
                !isOrmUser) ||
              (type === "template_global" && !isOrmUser) ||
              (type === "advance_settings" &&
                quick_filters &&
                templateDetails?.template_type === "competition" &&
                !isOrmUser) ||
              (type === "advance_settings" &&
                templateDetails?.template_type === "competition" &&
                !isOrmUser)) &&
              shouldShowCompetitorList && (
                <div className="portlet-label text-Darkgray mb-1 d-flex align-items-center justify-content-between">
                  <span className="font-weight500">Competitor List</span>
                  <span
                    className="cursor-pointer text-center"
                    style={{
                      width: "2.2rem",
                      height: "100%",
                      verticalAlign: "middle",
                    }}
                    onClick={() =>
                      setCompetitorBrandsCollapse(!competitorBrandsCollapse)
                    }
                  >
                    <img
                      src={
                        authParams?.theme_type === "1"
                          ? accoArrowWhite
                          : accoArrow
                      }
                      alt="arrow"
                      className="accordionArrow"
                      style={{
                        transform: `rotate(${
                          competitorBrandsCollapse ? "0deg" : "180deg"
                        })`,
                      }}
                    />
                  </span>
                </div>
              )}
            {((type === "widgetMaker" && !isOrmUser) ||
              (type === "share_modal" &&
                !quick_filters &&
                !brandlist_brandgroup_select &&
                !isOrmUser) ||
              (type === "share_dashboard_global" &&
                !quick_filters &&
                !brandlist_brandgroup_select &&
                !isOrmUser) ||
              (type === "global_dashboard" &&
                !quick_filters &&
                !brandlist_brandgroup_select &&
                !isOrmUser) ||
              (type === "CommandCenter" &&
                !quick_filters &&
                !brandlist_brandgroup_select &&
                !isOrmUser) ||
              (type === "template_global" && !isOrmUser) ||
              (type === "advance_settings" &&
                quick_filters &&
                templateDetails?.template_type === "competition" &&
                !isOrmUser) ||
              (type === "advance_settings" &&
                templateDetails?.template_type === "competition" &&
                !isOrmUser)) &&
            shouldShowCompetitorList &&
            competitorBrandsValue?.length > 0 &&
            competitorBrandsCollapse ? (
              competitorBrandsValue?.map((el, i) => {
                return (
                  <div
                    className="text_regular  mb-2"
                    key={`Competiterbrand_list${i}`}
                  >
                    <div
                      style={{
                        lineHeight: "normal",
                        cursor: "pointer",
                      }}
                    >
                      <Popover
                        // open={
                        //   selectLogicalBrandValue[type]?.data?.columns[0]
                        //     ?.brand_friendly_name === el?.brand_friendly_name
                        //     ? true
                        //     : false
                        // }
                        content={
                          <div
                            className="custom_scroll p-2"
                            style={{
                              maxHeight: "20rem",
                              overflow: "auto",
                              maxWidth: "20rem",
                            }}
                          >
                            {el?.comp_brand_list?.map((e, cIndex) => {
                              return (
                                <Checkbox
                                  key={`Competiterbrand_list${i}TooltipList${cIndex}`}
                                  onChange={(item) =>
                                    handleOnSelectCompetitor(item, e, el)
                                  }
                                  value={e?.comp_brand_friendly_name}
                                  checked={
                                    logicalBrandCheckedItems[type]?.data &&
                                    logicalBrandCheckedItems[type]?.data[
                                      e?.comp_brand_name + el?.brand_name
                                    ]
                                  }
                                  style={{
                                    display: "inline-flex",
                                    lineHeight: "normal",
                                    //alignItems: "center",
                                    width: "100%",
                                    marginLeft: "0",
                                  }}
                                  disabled={
                                    selectLogicalBrandValue[type]?.data
                                      ?.columns[0]?.brand_friendly_name !==
                                    el?.brand_friendly_name
                                      ? true
                                      : false
                                  }
                                >
                                  <span
                                    style={{
                                      maxHeight: "20rem",
                                      overflow: "auto",
                                    }}
                                    className="mb-0"
                                  >
                                    <span
                                      className=" "
                                      style={
                                        e?.comp_brand_color
                                          ? {
                                              width: "1.2rem",
                                              height: "1.2rem",
                                              borderRadius: "50%",
                                              display: "inline-block",
                                              marginTop: "0.2rem",
                                              marginRight: "0.5rem",
                                              backgroundColor:
                                                e?.comp_brand_color,
                                            }
                                          : {
                                              width: "1.2rem",
                                              height: "1.2rem",
                                              borderRadius: "50%",
                                              display: "inline-block",
                                              marginTop: "0.2rem",
                                              marginRight: "0.5rem",
                                              border:
                                                "0.1rem solid var(--secondary-color)",
                                            }
                                      }
                                    ></span>
                                    {e?.comp_brand_friendly_name}
                                  </span>
                                </Checkbox>
                              );
                            })}
                          </div>
                        }
                        placement="right"
                        overlayClassName={
                          authParams?.theme_type === "1"
                            ? "darkTheme brandsdropdown"
                            : "lightTheme brandsdropdown"
                        }
                      >
                        <div className="w-100 d-flex justify-content-between ">
                          <div>
                            <Checkbox
                              onChange={() =>
                                handleOnSelectChange(
                                  null,
                                  el?.brand_name,
                                  "competitor",
                                  el
                                )
                              }
                              checked={
                                selectLogicalBrandValue[type]?.data?.columns[0]
                                  ?.competitor &&
                                selectLogicalBrandValue[type]?.data?.columns[0]
                                  ?.brand_friendly_name ===
                                  el?.brand_friendly_name
                                  ? true
                                  : false
                              }
                            ></Checkbox>

                            <span className="ml-2">
                              <span
                                className=" "
                                style={
                                  el?.brand_color
                                    ? {
                                        width: "1.2rem",
                                        height: "1.2rem",
                                        borderRadius: "50%",
                                        display: "inline-block",
                                        marginTop: "0.2rem",
                                        marginRight: "0.5rem",
                                        backgroundColor: el?.brand_color,
                                      }
                                    : {
                                        width: "1.2rem",
                                        height: "1.2rem",
                                        borderRadius: "50%",
                                        display: "inline-block",
                                        marginTop: "0.2rem",
                                        marginRight: "0.5rem",
                                        border:
                                          "0.1rem solid var(--secondary-color)",
                                      }
                                }
                              ></span>
                              {el?.brand_friendly_name}
                              {selectLogicalBrandValue[type]?.data?.columns[0]
                                ?.competitor &&
                              selectLogicalBrandValue[type]?.data?.columns[0]
                                ?.brand_friendly_name ===
                                el?.brand_friendly_name
                                ? "(" +
                                  selectLogicalBrandValue[type]?.data
                                    ?.columns[0]?.competitorList?.length +
                                  "/" +
                                  el?.comp_brand_list?.length +
                                  ")"
                                : "(" + el?.comp_brand_list?.length + ")"}
                            </span>
                          </div>

                          <img
                            onClick={(item) =>
                              handleOnSelectChange(
                                item,
                                el?.brand_name,
                                "competitor",
                                el
                              )
                            }
                            src={
                              selectLogicalBrandValue[type]?.data?.columns[0]
                                ?.competitor &&
                              selectLogicalBrandValue[type]?.data?.columns[0]
                                ?.brand_friendly_name ===
                                el?.brand_friendly_name
                                ? Blue_check
                                : Gray_check
                            }
                            className="mr-2"
                          />
                        </div>
                      </Popover>
                    </div>
                  </div>
                );
              })
            ) : (
              <>
                {(type === "widgetMaker" ||
                  type === "share_modal" ||
                  type === "global_dashboard" ||
                  type === "share_dashboard_global" ||
                  type === "CommandCenter" ||
                  type === "template_global" ||
                  (type === "advance_settings" &&
                    templateDetails?.template_type === "competition")) &&
                  !quick_filters &&
                  !brandlist_brandgroup_select &&
                  !isOrmUser &&
                  shouldShowCompetitorList &&
                  competitorBrandsCollapse && (
                    <div className="font-size12 text-gray">
                      {competitorBrands?.length <= 0
                        ? "No Brand Lists"
                        : "No search result found"}
                    </div>
                  )}
              </>
            )}
          </div>

          <div
            className={`footer w-100 bg__white d-flex justify-content-between border-top`}
            style={{ padding: "0.8rem 1.5rem" }}
          >
            {type === "advance_settings" ||
            type === "dashboard_section" ||
            type === "dashboard_widget" ||
            type === "template_section" ||
            type === "template_widget" ? (
              <>
                <Button
                  onClick={() => handleClear(false)}
                  className="btn_Clear"
                >
                  Clear
                </Button>
                <div className="d-flex justify-content-between">
                  <Button
                    onClick={() => handleCancel(false)}
                    className="btn_Clear mr-15"
                  >
                    Cancel
                  </Button>
                  <Button
                    onClick={() => handleDone(false)}
                    type="primary"
                    className={`ant-btn-primary_blue`}
                    disabled={
                      !selectLogicalBrandValue[type]?.data ||
                      selectLogicalBrandValue[type]?.data?.columns?.length === 0
                    }
                  >
                    Done
                  </Button>
                </div>
              </>
            ) : (
              <>
                <Button
                  onClick={() => handleCancel(false)}
                  className="btn_Clear"
                >
                  Cancel
                </Button>
                <Button
                  onClick={() => handleDone(false)}
                  type="primary"
                  className={`ant-btn-primary_blue`}
                  disabled={
                    !selectLogicalBrandValue[type]?.data ||
                    selectLogicalBrandValue[type]?.data?.columns?.length === 0
                  }
                >
                  Done
                </Button>
              </>
            )}
          </div>
        </>
      }
      title={null}
      trigger="click"
      open={
        visible &&
        !personalisationSettingsInPersonalisationState?.isPersonalizationPreviewOpen
      }
      onOpenChange={(e) => {
        !(
          authParams?.screen_id === "000-000-550" &&
          screenSettings?.is_competitor
        ) && handleVisibleChange(e);
      }}
      placement="bottomLeft"
      overlayClassName={
        authParams?.theme_type === "1"
          ? "darkTheme brandsdropdown"
          : "lightTheme brandsdropdown"
      }
    >
      <div
        style={{
          padding: type === "CommandCenter" ? "0rem" : "0.8rem 1.2rem",
          borderRadius: "0.4rem",
          minWidth: "18rem",
          maxWidth: type === "share_modal" ? "55rem" : "100%",
        }}
        className={` ${
          type === "CommandCenter" ? "mr-15" : "border-color border"
        }  text_regular cursor-pointer d-flex align-items-center justify-content-between command-center-header ${
          (graphLoader ||
            aggregateLoader ||
            profileLoader ||
            authParams?.filterScreen) &&
          "disable"
        } ${
          authParams?.screen_id === "000-000-550" &&
          screenSettings?.is_competitor
            ? "CommandCenter__brand--disable"
            : ""
        } ${
          personalisationSettingsInPersonalisationState?.isPersonalizationPreviewOpen
            ? "disabled-cursor"
            : ""
        } `}
        onClick={(e) => e?.preventDefault()}
        ref={brandTitleContainer}
      >
        <div
          className="d-flex align-items-center"
          style={{ width: "calc(100% - 1.5rem)" }}
        >
          {type === "global_dashboard" || type === "share_dashboard_global" ? (
            <>
              {!selectLogicalBrandValue[type]?.data?.columns[0]?.competitor && (
                <Image
                  style={{
                    width: "1.8rem",
                    maxHeight: "1.8rem",
                    borderRadius: "50%",
                    marginRight: "0.5rem",
                  }}
                  src={
                    selectLogicalBrandValue[type]?.data?.columns[0]?.brand_image
                      ? selectLogicalBrandValue[type]?.data?.columns[0]
                          ?.brand_image
                      : DefaultBrandLogo
                  }
                  fallback={DefaultBrandLogo}
                  preview={false}
                  //className="border border-color box-shadow"
                />
              )}
              <div
                className="mr-1 text_regular text-ellipsis"
                // style={{ maxWidth: "9.8rem" }}
              >
                {!selectLogicalBrandValue[type]?.data ||
                selectLogicalBrandValue[type]?.data?.columns?.length === 0
                  ? "No Brand"
                  : logicalBrandCheckedItems[type]?.data.All
                  ? "All"
                  : selectLogicalBrandValue[type]?.data?.columns?.length > 0 &&
                    selectLogicalBrandValue[type]?.data?.columns[0]
                      ?.brand_friendly_name
                  ? selectLogicalBrandValue[type]?.data?.columns[0]
                      ?.brand_friendly_name
                  : "No Brand"}
              </div>

              <div
                className={`text_regular mr-1 ${
                  !selectLogicalBrandValue[type]?.data ||
                  (selectLogicalBrandValue[type]?.data?.columns &&
                    !selectLogicalBrandValue[type]?.data?.columns[0]
                      ?.competitorList &&
                    selectLogicalBrandValue[type]?.data?.columns?.length <=
                      1) ||
                  logicalBrandCheckedItems[type]?.data.All
                    ? "d-none"
                    : ""
                }`}
              >
                +
                {selectLogicalBrandValue[type]?.data
                  ? selectLogicalBrandValue[type]?.data &&
                    (selectLogicalBrandValue[type]?.data?.columns[0]
                      ?.competitorList
                      ? selectLogicalBrandValue[type]?.data?.columns[0]
                          ?.competitorList?.length
                      : selectLogicalBrandValue[type]?.data?.columns?.length -
                        1)
                  : "(0)"}
              </div>
            </>
          ) : type === "dashboard_section" ? (
            <>
              <div className="mr-1 text_regular">
                {!selectLogicalBrandValue[type]?.data ||
                selectLogicalBrandValue[type]?.data?.columns?.length === 0
                  ? "No Brand"
                  : logicalBrandCheckedItems[type]?.data.All
                  ? "All"
                  : selectLogicalBrandValue[type]?.data?.columns?.length > 0 &&
                    selectLogicalBrandValue[type]?.data?.columns[0]
                      ?.brand_friendly_name}
              </div>

              <div
                className={`text_regular ml-1 mr-1 ${
                  !selectLogicalBrandValue[type]?.data ||
                  selectLogicalBrandValue[type]?.data?.columns?.length <= 1 ||
                  logicalBrandCheckedItems[type]?.data.All
                    ? "d-none"
                    : ""
                }`}
              >
                +
                {selectLogicalBrandValue[type]?.data
                  ? selectLogicalBrandValue[type]?.data &&
                    selectLogicalBrandValue[type]?.data?.columns?.length - 1
                  : "(0)"}
              </div>
            </>
          ) : type === "dashboard_widget" ? (
            <>
              <div
                className="mr-1 text_regular text-ellipsis"
                // style={{ maxWidth: "9.8rem" }}
              >
                {widget_metadata?.type === "predefined" &&
                widget_metadata?.allow_logical_group
                  ? !selectLogicalBrandValue[type]?.data ||
                    selectLogicalBrandValue[type]?.data?.columns?.length === 0
                    ? "No Brand"
                    : selectLogicalBrandValue[type]?.data?.columns?.length > 0
                    ? selectLogicalBrandValue[type]?.data?.columns[0]
                        ?.brand_friendly_name
                    : "No Brand"
                  : widget_metadata?.type === "predefined" &&
                    !widget_metadata?.profile_filters_flag
                  ? !selectLogicalBrandValue[type]?.data ||
                    selectLogicalBrandValue[type]?.data?.columns?.length === 0
                    ? "No Brand"
                    : selectLogicalBrandValue[type]?.data?.columns?.length >
                        0 &&
                      !selectLogicalBrandValue[type]?.data?.columns[0]
                        ?.brand_group_name &&
                      !selectLogicalBrandValue[type]?.data?.columns[0]
                        ?.competitor
                    ? selectLogicalBrandValue[type]?.data?.columns[0]
                        ?.brand_friendly_name
                    : "No Brand"
                  : !selectLogicalBrandValue[type]?.data ||
                    selectLogicalBrandValue[type]?.data?.columns?.length === 0
                  ? "No Brand"
                  : logicalBrandCheckedItems[type]?.data.All
                  ? "All"
                  : selectLogicalBrandValue[type]?.data?.columns?.length > 0 &&
                    selectLogicalBrandValue[type]?.data?.columns[0]
                      ?.brand_friendly_name}
              </div>

              <div
                className={`text_regular ml-1 mr-1 ${
                  !selectLogicalBrandValue[type]?.data ||
                  selectLogicalBrandValue[type]?.data?.columns?.length <= 1 ||
                  logicalBrandCheckedItems[type]?.data.All
                    ? "d-none"
                    : ""
                }`}
              >
                +
                {selectLogicalBrandValue[type]?.data
                  ? selectLogicalBrandValue[type]?.data &&
                    selectLogicalBrandValue[type]?.data?.columns?.length - 1
                  : "(0)"}
              </div>
            </>
          ) : type === "template_global" ? (
            <>
              {!selectLogicalBrandValue[type]?.data?.columns[0]?.competitor && (
                <Image
                  style={{
                    width: "1.8rem",
                    maxHeight: "1.8rem",
                    borderRadius: "50%",
                    marginRight: "0.5rem",
                  }}
                  src={
                    selectLogicalBrandValue[type]?.data?.columns[0]?.brand_image
                      ? selectLogicalBrandValue[type]?.data?.columns[0]
                          ?.brand_image
                      : DefaultBrandLogo
                  }
                  fallback={DefaultBrandLogo}
                  preview={false}
                  //className="border border-color box-shadow"
                />
              )}
              <div
                className="mr-1 text_regular text-ellipsis"
                style={{ maxWidth: "9.8rem" }}
              >
                {!selectLogicalBrandValue[type]?.data ||
                selectLogicalBrandValue[type]?.data?.columns?.length === 0
                  ? "No Brand"
                  : logicalBrandCheckedItems[type]?.data.All
                  ? "All"
                  : selectLogicalBrandValue[type]?.data?.columns?.length > 0 &&
                    selectLogicalBrandValue[type]?.data?.columns[0]
                      ?.brand_friendly_name}
              </div>

              <div
                className={`text_regular ml-1 mr-1 ${
                  !selectLogicalBrandValue[type]?.data ||
                  (selectLogicalBrandValue[type]?.data?.columns &&
                    !selectLogicalBrandValue[type]?.data?.columns[0]
                      ?.competitorList &&
                    selectLogicalBrandValue[type]?.data?.columns?.length <=
                      1) ||
                  logicalBrandCheckedItems[type]?.data.All
                    ? "d-none"
                    : ""
                }`}
              >
                +
                {selectLogicalBrandValue[type]?.data
                  ? selectLogicalBrandValue[type]?.data &&
                    (selectLogicalBrandValue[type]?.data?.columns[0]
                      ?.competitorList
                      ? selectLogicalBrandValue[type]?.data?.columns[0]
                          ?.competitorList?.length
                      : selectLogicalBrandValue[type]?.data?.columns?.length -
                        1)
                  : "(0)"}
              </div>
            </>
          ) : type === "advance_settings" ? (
            <>
              <div
                className="mr-1 text_regular text-ellipsis"
                // style={{ maxWidth: "9.8rem" }}
              >
                {!selectLogicalBrandValue[type]?.data ||
                selectLogicalBrandValue[type]?.data?.columns?.length === 0
                  ? "No Brand"
                  : logicalBrandCheckedItems[type]?.data.All
                  ? "All"
                  : selectLogicalBrandValue[type]?.data?.columns?.length > 0 &&
                    selectLogicalBrandValue[type]?.data?.columns[0]
                      ?.brand_friendly_name}
              </div>

              <div
                className={`text_regular ml-1 mr-1 ${
                  !selectLogicalBrandValue[type]?.data ||
                  (selectLogicalBrandValue[type]?.data?.columns &&
                    !selectLogicalBrandValue[type]?.data?.columns[0]
                      ?.competitorList &&
                    selectLogicalBrandValue[type]?.data?.columns?.length <=
                      1) ||
                  logicalBrandCheckedItems[type]?.data.All
                    ? "d-none"
                    : ""
                }`}
              >
                +
                {selectLogicalBrandValue[type]?.data
                  ? selectLogicalBrandValue[type]?.data &&
                    (selectLogicalBrandValue[type]?.data?.columns[0]
                      ?.competitorList
                      ? selectLogicalBrandValue[type]?.data?.columns[0]
                          ?.competitorList?.length
                      : selectLogicalBrandValue[type]?.data?.columns?.length -
                        1)
                  : "(0)"}
              </div>
            </>
          ) : type === "template_section" ? (
            <>
              <div
                className="mr-1 text_regular text-ellipsis"
                // style={{ maxWidth: "9.8rem" }}
              >
                {!selectLogicalBrandValue[type]?.data ||
                selectLogicalBrandValue[type]?.data?.columns?.length === 0
                  ? "No Brand"
                  : logicalBrandCheckedItems[type]?.data.All
                  ? "All"
                  : selectLogicalBrandValue[type]?.data?.columns?.length > 0 &&
                    selectLogicalBrandValue[type]?.data?.columns[0]
                      ?.brand_friendly_name}
              </div>

              <div
                className={`text_regular ml-1 mr-1 ${
                  !selectLogicalBrandValue[type]?.data ||
                  selectLogicalBrandValue[type]?.data?.columns?.length <= 1 ||
                  logicalBrandCheckedItems[type]?.data.All
                    ? "d-none"
                    : ""
                }`}
              >
                +
                {selectLogicalBrandValue[type]?.data
                  ? selectLogicalBrandValue[type]?.data &&
                    selectLogicalBrandValue[type]?.data?.columns?.length - 1
                  : "(0)"}
              </div>
            </>
          ) : type === "template_widget" ? (
            <>
              <div
                className="mr-1 text_regular text-ellipsis"
                // style={{ maxWidth: "9.8rem" }}
              >
                {widget_metadata?.type === "predefined" &&
                widget_metadata?.allow_logical_group
                  ? !selectLogicalBrandValue[type]?.data ||
                    selectLogicalBrandValue[type]?.data?.columns?.length === 0
                    ? "No Brand"
                    : selectLogicalBrandValue[type]?.data?.columns?.length > 0
                    ? selectLogicalBrandValue[type]?.data?.columns[0]
                        ?.brand_friendly_name
                    : "No Brand"
                  : widget_metadata?.type === "predefined" &&
                    !widget_metadata?.profile_filters_flag
                  ? !selectLogicalBrandValue[type]?.data ||
                    selectLogicalBrandValue[type]?.data?.columns?.length === 0
                    ? "No Brand"
                    : selectLogicalBrandValue[type]?.data?.columns?.length >
                        0 &&
                      !selectLogicalBrandValue[type]?.data?.columns[0]
                        ?.brand_group_name &&
                      !selectLogicalBrandValue[type]?.data?.columns[0]
                        ?.competitor
                    ? selectLogicalBrandValue[type]?.data?.columns[0]
                        ?.brand_friendly_name
                    : "No Brand"
                  : !selectLogicalBrandValue[type]?.data ||
                    selectLogicalBrandValue[type]?.data?.columns?.length === 0
                  ? "No Brand"
                  : logicalBrandCheckedItems[type]?.data?.All
                  ? "All"
                  : selectLogicalBrandValue[type]?.data?.columns?.length > 0 &&
                    selectLogicalBrandValue[type]?.data?.columns[0]
                      ?.brand_friendly_name}
              </div>

              <div
                className={`text_regular ml-1 mr-1 ${
                  !selectLogicalBrandValue[type]?.data ||
                  selectLogicalBrandValue[type]?.data?.columns?.length <= 1 ||
                  logicalBrandCheckedItems[type]?.data.All
                    ? "d-none"
                    : ""
                }`}
              >
                +
                {selectLogicalBrandValue[type]?.data
                  ? selectLogicalBrandValue[type]?.data &&
                    selectLogicalBrandValue[type]?.data?.columns?.length - 1
                  : "(0)"}
              </div>
            </>
          ) : type === "graph_page" ? (
            <>
              <div
                className="mr-1 text_regular text-ellipsis"
                // style={{ maxWidth: "9.8rem" }}
              >
                {!selectLogicalBrandValue[type]?.data ||
                selectLogicalBrandValue[type]?.data?.columns?.length === 0
                  ? "No Brand"
                  : logicalBrandCheckedItems[type]?.data.All
                  ? "All"
                  : selectLogicalBrandValue[type]?.data?.columns?.length > 0 &&
                    selectLogicalBrandValue[type]?.data?.columns[0]
                      ?.brand_friendly_name}
              </div>

              <div
                className={`text_regular ml-1 mr-1 ${
                  !selectLogicalBrandValue[type]?.data ||
                  selectLogicalBrandValue[type]?.data?.columns?.length <= 1 ||
                  logicalBrandCheckedItems[type]?.data.All
                    ? "d-none"
                    : ""
                }`}
              >
                +
                {selectLogicalBrandValue[type]?.data
                  ? selectLogicalBrandValue[type]?.data &&
                    selectLogicalBrandValue[type]?.data?.columns?.length - 1
                  : "(0)"}
              </div>
            </>
          ) : type === "preview" ? (
            <>
              <div
                className="mr-1 text_regular text-ellipsis"
                // style={{ maxWidth: "9.8rem" }}
              >
                {!selectLogicalBrandValue[type]?.data ||
                selectLogicalBrandValue[type]?.data?.columns?.length === 0
                  ? "No Brand"
                  : logicalBrandCheckedItems[type]?.data.All
                  ? "All"
                  : selectLogicalBrandValue[type]?.data?.columns?.length > 0 &&
                    selectLogicalBrandValue[type]?.data?.columns[0]
                      ?.brand_friendly_name}
              </div>

              <div
                className={`text_regular ml-1 mr-1 ${
                  !selectLogicalBrandValue[type]?.data ||
                  selectLogicalBrandValue[type]?.data?.columns?.length <= 1 ||
                  logicalBrandCheckedItems[type]?.data.All
                    ? "d-none"
                    : ""
                }`}
              >
                +
                {selectLogicalBrandValue[type]?.data
                  ? selectLogicalBrandValue[type]?.data &&
                    selectLogicalBrandValue[type]?.data?.columns?.length - 1
                  : "(0)"}
              </div>
            </>
          ) : type === "orm_dashboard" ? (
            <>
              <div
                className="mr-1 text_regular text-ellipsis"
                // style={{ maxWidth: "9.8rem" }}
              >
                {!selectLogicalBrandValue[type]?.data ||
                selectLogicalBrandValue[type]?.data?.columns?.length === 0
                  ? "No Brand"
                  : logicalBrandCheckedItems[type]?.data.All
                  ? "All"
                  : selectLogicalBrandValue[type]?.data?.columns?.length > 0 &&
                    selectLogicalBrandValue[type]?.data?.columns[0]
                      ?.brand_friendly_name}
              </div>

              <div
                className={`text_regular ml-1 mr-1 ${
                  !selectLogicalBrandValue[type]?.data ||
                  selectLogicalBrandValue[type]?.data?.columns?.length <= 1 ||
                  logicalBrandCheckedItems[type]?.data.All
                    ? "d-none"
                    : ""
                }`}
              >
                +
                {selectLogicalBrandValue[type]?.data
                  ? selectLogicalBrandValue[type]?.data &&
                    selectLogicalBrandValue[type]?.data?.columns?.length - 1
                  : "(0)"}
              </div>
            </>
          ) : type === "widgetMaker" ? (
            <>
              {!selectLogicalBrandValue[type]?.data?.columns[0]?.competitor && (
                <Image
                  style={{
                    width: "1.8rem",
                    maxHeight: "1.8rem",
                    borderRadius: "50%",
                    marginRight: "0.5rem",
                  }}
                  src={
                    selectLogicalBrandValue[type]?.data?.columns[0]?.brand_image
                      ? selectLogicalBrandValue[type]?.data?.columns[0]
                          ?.brand_image
                      : DefaultBrandLogo
                  }
                  fallback={DefaultBrandLogo}
                  preview={false}
                  //className="border border-color box-shadow"
                />
              )}
              <div
                className="mr-1 text_regular text-ellipsis"
                // style={{ maxWidth: "9.8rem" }}
              >
                {!selectLogicalBrandValue[type]?.data ||
                selectLogicalBrandValue[type]?.data?.columns?.length === 0
                  ? "No Brand"
                  : logicalBrandCheckedItems[type]?.data.All
                  ? "All"
                  : selectLogicalBrandValue[type]?.data?.columns?.length > 0 &&
                    selectLogicalBrandValue[type]?.data?.columns[0]
                      ?.brand_friendly_name}
              </div>
              <div
                className={`text_regular ml-1 mr-1 ${
                  !selectLogicalBrandValue[type]?.data ||
                  (selectLogicalBrandValue[type]?.data?.columns &&
                    !selectLogicalBrandValue[type]?.data?.columns[0]
                      ?.competitorList &&
                    selectLogicalBrandValue[type]?.data?.columns?.length <=
                      1) ||
                  logicalBrandCheckedItems[type]?.data.All
                    ? "d-none"
                    : ""
                }`}
              >
                +
                {selectLogicalBrandValue[type]?.data
                  ? selectLogicalBrandValue[type]?.data &&
                    (selectLogicalBrandValue[type]?.data?.columns[0]
                      ?.competitorList
                      ? selectLogicalBrandValue[type]?.data?.columns[0]
                          ?.competitorList?.length
                      : selectLogicalBrandValue[type]?.data?.columns?.length -
                        1)
                  : "(0)"}
              </div>
            </>
          ) : type === "CommandCenter" || type === "CommandCenterCampaign" ? (
            <>
              <Tooltip
                title={
                  authParams?.screen_id === "000-000-550" &&
                  screenSettings?.is_competitor
                    ? "Comparison mode is on"
                    : ""
                }
                placement="bottom"
              >
                <div className={`d-flex align-items-center `}>
                  {!selectLogicalBrandValue[type]?.data?.columns[0]
                    ?.competitor && (
                    <Image
                      style={{
                        width: "1.8rem",
                        maxHeight: "1.8rem",
                        borderRadius: "50%",
                        marginRight: "0.5rem",
                      }}
                      src={
                        selectLogicalBrandValue[type]?.data?.columns[0]
                          ?.brand_image
                          ? selectLogicalBrandValue[type]?.data?.columns[0]
                              ?.brand_image
                          : DefaultBrandLogo
                      }
                      fallback={DefaultBrandLogo}
                      preview={false}
                      //className="border border-color box-shadow"
                    />
                  )}
                  <div
                    className="mr-1 text_regular text-ellipsis header__brandName"
                    // style={{ maxWidth: "9.8rem" }}
                  >
                    {!selectLogicalBrandValue[type]?.data ||
                    selectLogicalBrandValue[type]?.data?.columns?.length === 0
                      ? "No Brand"
                      : logicalBrandCheckedItems[type]?.data.All
                      ? "All"
                      : selectLogicalBrandValue[type]?.data?.columns?.length >
                          0 &&
                        selectLogicalBrandValue[type]?.data?.columns[0]
                          ?.brand_friendly_name}
                  </div>

                  <div
                    className={`text_regular ml-1 mr-1 ${
                      !selectLogicalBrandValue[type]?.data ||
                      (selectLogicalBrandValue[type]?.data?.columns &&
                        !selectLogicalBrandValue[type]?.data?.columns[0]
                          ?.competitorList &&
                        selectLogicalBrandValue[type]?.data?.columns?.length <=
                          1) ||
                      logicalBrandCheckedItems[type]?.data.All
                        ? "d-none"
                        : ""
                    }`}
                  >
                    +
                    {selectLogicalBrandValue[type]?.data
                      ? selectLogicalBrandValue[type]?.data &&
                        (selectLogicalBrandValue[type]?.data?.columns[0]
                          ?.competitorList
                          ? selectLogicalBrandValue[type]?.data?.columns[0]
                              ?.competitorList?.length
                          : selectLogicalBrandValue[type]?.data?.columns
                              ?.length - 1)
                      : "(0)"}
                  </div>
                </div>
              </Tooltip>
            </>
          ) : (
            type === "share_modal" && (
              <>
                <div
                  className="mr-1 text_regular text-ellipsis"
                  // style={{ maxWidth: "9.8rem" }}
                >
                  {!selectLogicalBrandValue[type]?.data ||
                  selectLogicalBrandValue[type]?.data?.columns?.length === 0
                    ? "No Brand"
                    : logicalBrandCheckedItems[type]?.data.All
                    ? "All"
                    : selectLogicalBrandValue[type]?.data?.columns?.length >
                        0 &&
                      selectLogicalBrandValue[type]?.data?.columns[0]
                        ?.brand_friendly_name}
                </div>

                <div
                  className={`text_regular mr-1 ${
                    !selectLogicalBrandValue[type]?.data ||
                    (selectLogicalBrandValue[type]?.data?.columns &&
                      !selectLogicalBrandValue[type]?.data?.columns[0]
                        ?.competitorList &&
                      selectLogicalBrandValue[type]?.data?.columns?.length <=
                        1) ||
                    logicalBrandCheckedItems[type]?.data.All
                      ? "d-none"
                      : ""
                  }`}
                >
                  +
                  {selectLogicalBrandValue[type]?.data
                    ? selectLogicalBrandValue[type]?.data &&
                      (selectLogicalBrandValue[type]?.data?.columns[0]
                        ?.competitorList
                        ? selectLogicalBrandValue[type]?.data?.columns[0]
                            ?.competitorList?.length
                        : selectLogicalBrandValue[type]?.data?.columns?.length -
                          1)
                    : "(0)"}
                </div>
              </>
            )
          )}
        </div>
        <span className="accordionArrow d-flex align-items-center ml-1">
          {" "}
          {authParams?.theme_type === "1"
            ? getDynamicIconColor("accordion_arrow_white")
            : getDynamicIconColor("accordion_arrow")}
        </span>
        {/* {authParams?.theme_type == "1"
          ? getDynamicIconColor("accordion_arrow")
          : getDynamicIconColor("accordion_arrow_white")} */}
        {/* <img
          src={authParams?.theme_type === "1" ? accoArrowWhite : accoArrow}
          className="accordionArrow p-0"
          alt="arrow"
        /> */}
      </div>
    </Popover>
  );
};

export default React.memo(BrandsLogicalGroup, isEqual);
